module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("A month after the arrival of the first Spitfires on Malta, the urgent need for considerable reinforcements caused the air parties of two established squadrons to be carried to the island on the aircraft carrier USS "), _c('i', [_vm._v("Wasp")]), _vm._v(", borrowed for the task from the US Navy. The three previous deliveries had taken just 31 Spitfires to the island, few of which now remained intact. Then on 20 April 47 more were flown off as 601 and 603 Squadrons, commanded respectively by Sqn Ldr J.D.Bisdee, DFC, and Sqn Ldr Lord David Douglas-Hamilton.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Even as delivery was underway, the ground parties of both units had been despatched via the ocean route, not initially at any rate to join the air parties on Malta, but to join RAF Egypt. Posted with them at the same time were four more squadrons, all of which had been flying Spitfires in the United Kingdom. These units all sailed on HMT K6 (ex SS "), _c('i', [_vm._v("Rangitata")]), _vm._v(") on 15 April, reaching Durban, South Africa, during mid May, and then arriving in Egypt in the latter part of June. Amongst them was 601 Squadron’s commanding officer, Sqn Ldr R.G.A.Barclay, DFC, who on arrival did not go on to Malta to rejoin his unit, but was instead posted to command 238 Squadron. On the island command had meanwhile passed to Sqn Ldr John Bisdee while on the way out on "), _c('i', [_vm._v("Wasp")]), _vm._v(". Once more, aircraft did not actually accompany the units now arrived in Egypt, all of which (with the exception of 601 Squadron) were to wait many months to receive aircraft – and then these turned out in the first instance to be Hurricanes. Having despatched the personnel of so many units to the Middle East, one is bound to query just how experienced they were, given the critical months that slipped by before they were able to play any useful part in the proceedings.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Like 92 and 145 Squadrons, 74 Squadron (commanding officer Sqn Ldr G.P.H.Matthews, DFC) had seen considerable action during 1940 and early 1941, over Dunkirk, south-east England and Occupied France. Since then, however, it had spent many months on defensive duties in the north of England and in Northern Ireland; it no longer retained any of the experienced pilots of the early months of the war. 123 Squadron (Sqn Ldr D.M.Jack) was a recently-formed unit which had been acting as an OTU. 134 Squadron (Sqn Ldr A.M.D.Howes) had been one of the units forming 151 Wing which had delivered and operated Hurricanes in north Russia, but had been at Catterick in Yorkshire since its return in December 1941, having only recently become re-established in the UK and equipped with Spitfires. Finally, 417 Squadron (Sqn Ldr P.B.Pitcher) was an RCAF unit which had only been formed in late November 1941 and had been declared operational on Spitfires only one week before being ordered to prepare for the move to the Middle East. It would become the first, and the only, Canadian fighter unit to operate in the Mediterranean and Middle East.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In all cases the units had relatively experienced commanding officers and the occasional – very occasional – flight commanders who had actually been in combat. The vast majority of the pilots, as with the squadrons in the Middle East generally, were the rapidly-trained products of the Commonwealth Air Training Plan, now beginning to flow from their human production lines in rapidly growing numbers. Like the pilots of 92 Squadron, those of 74, 123 and 134 Squadrons ultimately found themselves attached to various of the resident units as temporary, or at times, permanent, reinforcements. The exception was 417 Squadron, which was held together more firmly because the commanders of the Royal Canadian Air Force had become very anxious (if not fixated) on achieving a high degree of ‘Canadianisation’ among its units.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All these units received Hurricanes before fully reverting to the Spitfires which ostensibly they had been sent out to fly, although in all cases it would be 1943 before they were fully so equipped. Perhaps the hardest-done-by unit was 123 Squadron which finally found itself at Habbaniya in Iraq in October 1942, receiving Gladiator II biplanes for a few weeks before sufficient Hurricanes became available.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thus it was that by the summer the situation on Malta had been considerably ameliorated. Supplies of Spitfires had become adequate for the island’s defence for the time being in any event. Given the beating that WDAF’s fighters would have been taking following the opening of Rommel’s Gazala offensive on 26 May, at the end of June the air party of 601 Squadron was sent from Malta to reinforce WDAF, the two parts of the unit being reunited at Maryut at the end of June. Although at that time 92 Squadron had still not received its Spitfires – and would not do so for several more weeks -the presence of both 145 and 601 at this critical juncture, at last began to be of some significance. For 603 Squadron, the story would be very different. In early August the air echelon was renumbered, the ground party then continuing to remain ‘in limbo’ for many more months before it became a full unit again, as will be described considerably later in our narrative.")])]), _c('p', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCH")]), _vm._v(" 1942")])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("With the arrival of March the WDAF fighter units were reorganised in a new 211 Group within which 258 and 262 Wings became respectively 243 and 239 Wings, while a new wing, 233, was formed. Squadrons initially allotted were as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("233 Wing")]), _vm._v(" – 94, 260, 2 SAAF and 4 SAAF Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("239 Wing")]), _vm._v(" – 3 RAAF, 112, 250 and 450 Squadrons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("243 Wing")]), _vm._v(" – 33, 73, 80 and 274 Squadrons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These units were now in the main based at Gambut. From 233 Wing, 94 Squadron was away undertaking further training, whereas in 239 Wing 3 RAAF Squadron was at this point detached for a rest. 238 Squadron, retained currently for defensive duties associated with the coastal convoys to Tobruk, received a new commanding officer when Sqn Ldr O’Neill was replaced by Sqn Ldr C.J. ‘Micky’ Mount, DFC, a Battle of France veteran.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was also a major change within the command structure of the Italian forces at this time when Gen Curio Barbasetti di Prun replaced Gen Giuseppe Gambara as chief of staff of armed forces in North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first 14 days of March brought further bad weather with heavy rain and storms which continued to reduce operational activity of all types.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_36.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("The ever-valuable work of the recovery units was very important to maintaining the strength of WDAF. Here a Hurricane of 73 Squadron, carrying the unit’s pre-war fuselage flash, is loaded onto a ‘Queen Mary’ trailer after its wings have been removed. BD930 later served with 335 and 127 Squadrons after repair.")])])])]), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('p', {
    staticClass: "fig-img"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_37.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("A number of shot-down Hurricanes are brought in for repair. To the right one aircraft painted with the fuselage flash of 73 Squadron may be seen, while in the left foreground is HB-D of 229 Squadron; behind this is an EZ-coded aircraft of 127 Squadron, and in the distance is probably EY of 80 Squadron.")])])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "h1a"
  }, [_c('b', [_vm._v("A L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITTLE-KNOWN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVERSION")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Before proceeding with the diary of events in the Western Desert and over Egypt, at this point a new series of events occurred which barely touched upon Allied considerations, but which were of immediate concern to the Italians. At the start of the month a new threat to their Libyan colony and to their forces had been detected by the Regia Aeronautica deep in the south of the country, in the Fezzan desert area. About 30 kilometres east of Sebha, Caproni Ghiblis of Aviazione Sahariana had sighted and strafed motor vehicles approaching Italian garrisons. The intruders were mixed formations of Chevrolet, Bedford and Ford lorries belonging to Chad-based Free French forces led by Gen Jacques-Philippe Leclerc. Initially, he had planned an attack to penetrate Libya from the south to join the British forces advancing along the coast. However, the Axis offensive in January had forced him to revise his rather ambitious plans, greatly reducing its goals. The new version provided a ‘touch and go’ offensive to harass Italian garrisons in order to distract forces from the northern front. The Leclerc column was formed by four independent patrols, the aerial support being provided by the Groupe Bretagne, composed of Nantes and Rennes Escadrilles. The former was led by Lt Jean Mahé and had four Martin Marylands (ex-French Martin 167s, known simply as ‘Glenns’) and a Potez 540. The latter, commanded by Lt Marcel Finance, had five Lysanders and three Potez 29s. Leclerc had moved from Chad on 17 February and ten days later surprised and overwhelmed the small garrison of Uigh el Kebir. Here he established his command post and on 28 February his forces managed to capture the Gatrun and Tegerri garrisons, but a patrol led by Cne Jacques Massu met strong resistance at Umm el Araneb and was forced to retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Fezzan – 3 March 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("The four Glenns of the Nantes Escadrille entered operations but were hampered by bad visibility. Cdt André Noel returned to his base at Vur without completing a reconnaissance he had set out to undertake, while the other three sought to find and bomb a fort at Murzuch. Only one crew found the target, Lt François Court’s aircraft releasing a single bomb on it. Court then became lost and belly-landed in the desert. The other two aircraft bombed unidentified forts, but one then ran out of fuel on its way back; ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("only Sous Lt Raymond managed to reach Vur safely.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("French Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Nantes Esc")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("2 Marylands force-landed in desert; Lt Jean Mahé and Lt François Court and crews safe")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Fezzan – 4 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sous Lt Pierre Grillet took off from Uigh el Kebir on a reconnaissance sortie in a Lysander, but flew into a sandstorm which caused him to crash-land at Gatrun. His aircraft was damaged beyond repair and he suffered severe injuries.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("French Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Rennes Esc")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Lysander P9184 crash-landed in storm, DBR; S/Lt Pierre Grillet badly injured")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Fezzan – 5 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As a result of the French aerial activity in Fezzan, Magg Michele Mandara, 160° Gruppo CT commanding officer, deployed four CR.42s to Sebha, led by Ten Eduardo Sorvillo. A single S.79 of 175"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia RST was also sent as a reinforcement, flown by Ten Giuseppe Pellizzotti.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the day the first sortie by Lysander P9181 was flown by Sgt Chef René Weill. Over Umm el Araneb, where Massu’s force had been driven back, he was fired on by AA. He managed to complete his reconnaissance and reported the results to Leclerc. Cdt Noel, who had aborted his sortie on 3rd, now completed his mission in Glenn BS765, sighting the newly-arrived Italian aircraft at Sebha.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Fezzan – 6 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The CR.42s of 160° Gruppo undertook their first sorties from Sebha, hunting French vehicles between there and Zuila, but without result.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Fezzan – 7 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The four CR.42s at Sebha now moved to Umm el Araneb. After a reconnaissance to Gatrun, they were bombed and strafed by the French Lysander P9197 of the Rennes Escadrille, flown by Lt Finance. The fighter of Ten Sorvillo was set on fire, the pilot suffering severe injuries, while S.Ten Piero Bertonasso’s CR.42 was slightly damaged. The pair of Fiats still serviceable took off immediately, flown by Serg Magg Duilio Bernardi and Serg Antonio Malavasi to hunt for the hostile aircraft. Bernardi found the Lysander and fired at it repeatedly, forcing it to land in the desert, trailing smoke. Finance took the gunner, Sgt Chef Fernand Leroy, who had been wounded in the leg, out of the aircraft and sought the cover of the smoke. It proved only to be a smoke bomb hit by a bullet from Bernardi’s guns.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile, Bernardi flew for some time over the grounded aircraft without attacking it further. Convinced that he had inflicted irreparable damage, he then departed. This allowed Finance, having got the gunner back on board, to take off and fly back to Uigh el Kebir.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At Umm el Araneb meantime, the wounded Sorvillo was put in an S.79 called to the spot and flown to Castel Benito. The S.79 flown by Ten Pellizzotti subsequently crashed at Sebha for unknown reasons, all crew being killed.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_38.jpg"
    }
  })])])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('b', [_vm._v("Fezzan – 8 March 1942")])])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Two more 160° Gruppo CR.42s were flown down to Sebha by Ten Raoul Francinetti and Serg Magg Aurelio Munich to replace the two which had been destroyed. Meanwhile, however, all the French aircraft left the area, retiring to their base at Faya in Chad, leaving Leclerc’s patrols without air cover.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Fezzan – 9 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The two newly-arrived 160° Gruppo pilots strafed Massu’s patrol, leaving one vehicle in flames and others damaged. Francinetti’s CR.42 was slightly damaged by small-arms fire. In the afternoon Francinetti, Malavasi and Munich again attacked Massu’s troops, this time near Uigh el Kebir, ten small trucks were claimed destroyed and others damaged. In practice, on 30 March an Italian patrol of 3“ Compagnia Sahariana found the wrecks of eight French vehicles. At this point the first Fezzan Campaign was at an end, French forces returning to Chad and the Italian garrisons being re-established.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-title1"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPAIGN")]), _c('br'), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UFTWAFFE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RDER OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _c('br'), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCH")]), _vm._v(" 1942")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_c('b', [_vm._v("Fliegerführer Afrika")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("Stab JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 109F-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("I./JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 109F-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("II./JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 109F-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("III./JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 109F-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("Stab StG 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 87R-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("He 111H-5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 110")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("I./StG 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Ju 87R-2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Ju 87R-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("II./StG 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Ju 87R-2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Ju 87R-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("4.(H)/12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Personnel only")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("2.(H)/14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Bf 110E-2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 110E-3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Hs 126B-1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Bf 109E-7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("Wüstennotstaffel")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Fi 156C-3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_c('b', [_vm._v("X. Fliegerkorps")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("Stab LG 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Ju 88A-5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("I./LG 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 88A-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Ju 88A-5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("He 111H-5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("II./LG 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 88A-4"), _c('br'), _vm._v("Ju 88A-5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("12./LG 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 88A-4"), _c('br'), _vm._v("Ju 88A-5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("II./KG 26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("He 111H-6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("1.(F)/121")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 88A-1"), _c('br'), _vm._v("Ju 88A-5"), _c('br'), _vm._v("Ju 88D-5"), _c('br'), _vm._v("Bf 110E-3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("1.(F)/122")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 88D-1"), _c('br'), _vm._v("Ju 88D-5"), _c('br'), _vm._v("Bf 109F-4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("2.(F)/123")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ju 88A-5"), _c('br'), _vm._v("Ju 88D-1"), _c('br'), _vm._v("Ju 88D-2"), _c('br'), _vm._v("Bf 110E-3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("2./SAGr 125")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("Ar 196A-3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-parax"
  }, [_vm._v("SAGr 126")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1x"
  }, [_vm._v("He 60"), _c('br'), _vm._v("Fokker T.VIII"), _c('br'), _vm._v("Ar 196A-3"), _c('br'), _vm._v("He 114A-2")])])])])])])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('b', [_vm._v("Monday, 2 March 1942")])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To return to the main front, on this date 11 Hurricanes of 274 Squadron were on patrol over Tobruk when two of the unit’s aircraft were shot down, both pilots suffering slight wounds and ending up together in Tobruk hospital. A third Hurricane crash-landed some 20 miles west of Gambut. These aircraft had all been shot down by 3./JG 27, Hptm Homuth and Lt Kugelbauer identifying them as P-40s – yet again. Sgt Dodds, flying in the lower of the two flights, became separated and reported meeting three MC.202s, one of which he claimed to have shot down in flames.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eight MC.200s of 150° Gruppo, led as usual by Magg Vizzotto, with six CR.42s of 154"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia, all escorted by 12 MC.202s of 6° Gruppo, took off at 1130 to strafe vehicles in the Taieb el Esem area. About 30 trucks were reported damaged but one CR.42 was shot down by AA, a second being damaged. Despite the presence of Bf 109s and MC.202s in the area during the morning, no engagements or losses have been discovered to match the claims of any of the Commonwealth pilots engaged.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_40.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("A 94 Squadron Kittyhawk I taxies out (without the ill-fated unit rudder markings) in the hands of newly-arrived Flt Sgt J.F.Edwards. He would make his first claim flying this aircraft on 23 March.")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_41.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday-Wednesday, 3/4 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("33 Squadron, based at Sidi Haneish where two Kittyhawks and a Tomahawk had been taken on strength, was now ordered to collect instead 12 Hurricane IIbs for re-equipment. Next day 80 Squadron moved to Gambut. 5 SAAF Squadron deployed forward to Maaten Bagush.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During 3rd an MC.202 of 17° Gruppo scrambled to intercept a Maryland from a detachment of 223 Squadron on reconnaissance duties, claiming to have probably shot this down. The Maryland crew returned, but with their aircraft shot-up, the crew reporting that they had been hit by both the Macchi and by Flak.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At this point 69° Gruppo OA was ordered to move its Ca.311s of 118"), _c('sup', [_vm._v("a")]), _vm._v(" and 123"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglie from Barce to Misurata.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_42.jpg"
    }
  })])])]), _c('div', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('b', [_vm._v("Wednesday, 4 March 1942")])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('table', {
    staticClass: "td2",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("213 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane FTR, left Port Said for Edcu, last plotted Lake Burillas, washed ashore at Baltim on 19th March; Sgt M.S.Lee KiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("208 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane I Z4064 hit by Flak NE Mechili, damaged Cat I; Sqn Ldr J.K.Rogers WiA")])])])])])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 5 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blue Section of 5 SAAF Squadron scrambled at 1619, Capt Duncan and Lt Thornhill-Cook intercepting and shooting down a Ju 88 of 2./LG 2 for the unit’s first victory. Three members of the German crew baled out and were captured by pilots of 1 SAAF Squadron who were returning to Cairo by truck. A few minutes after this success, a further bomber was attacked by two more of the unit’s pilots and claimed damaged. In the same area, however, another Ju 88 of the same unit involved in bombing Fuka airfield, encountered and shot down a Fleet Air Arm Albacore of 826 Squadron which was en route to Dekheila with four passengers aboard, all of whom were killed together with the crew.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_43.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 7 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Magg Vizzotto led 18 MC.200s of 150° Gruppo off at 0915 to attack a large concentration of armoured vehicles south of Ain el Gazala, cover to his formation being provided by 17 MC.202s of 17° Gruppo. Ten vehicles were claimed to have been left in flames with many more damaged. However, all but two of the MC.200s were hit by small-arms fire, and three of these force-landed at Tmimi while a fourth did likewise at Martuba. On return from this sortie an 81"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia MC.202 collided with another such aircraft from 88"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia; the 81"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia aircraft burst into flames, but the pilot escaped with only slight injuries.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("33 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane Z5311 dived into ground W LG. 115")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("81"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 6°Gr, 1°St CT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("MC.202 MM 7769 burnt after collision with MC.202 MM 7715 at Martuba, M.llo Giovanni Collovini WiA")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 8 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At 1400 Sgt Persse of 274 Squadron was attacked by a Bf 109 while landing at Gambut Main, and crashed, suffering leg wounds. Nine Bf 109s then shot-up the airfield, damaging nine Hurricanes on the ground there.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Ten 150° Gruppo MC.200s were off again at 1630, led by Cap Luigi Mariotti, on this occasion to escort Luftwaffe Ju 87s attacking Tobruk harbour. Indirect support was provided by Bf 109s, but these did not intervene when a reported 20 P-40s attacked. Six Kittyhawks each from 450 and 3 RAAF Squadrons had taken off at 1700 to intercept 15 Ju 87s with a very close escort identified as MC.200s and 202s. These were reported to be flying in a very tight formation made up of two echelons of five and four aircraft, and two Bf 109s above. It seems that the Italians initially mistook the Kittyhawks for friendly fighters and in consequence were hard-hit. The Australians claimed five MC.200s shot down, plus two MC.202s and two Ju 87s, adding three more MC.200s and one 202 as probables, and two damaged. ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("German and Italian reports were quite specific that no Ju 87s were lost, and this seems to be borne out by 112 Squadron which was patrolling over the forward area at the same time, meeting 15 Ju 87s escorted only by two MC.200s and two Bf 109s. The pilots of this unit claimed one Stuka and one Macchi shot down. 3./StG 3 reported that one aircraft was damaged in combat with Curtiss fighters some 30km northeast of Gazala, but that this aircraft landed safely at base. Similarly, after suffering the loss of five MC.200s, 150° Gruppo had one more force-land at Tmimi. Following this engagement the Regia Aeronautica demanded better co-operation from the German fighters.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("40 SAAF Squadron pilots were at this time attached to 208 Squadron, both to undertake some operations and to gain relevant experience before the latter unit was withdrawn for a rest.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_44.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 9 March 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Nine Kittyhawks of 112 Squadron were scrambled early from Gambut Main to which the unit had now moved, their task being to intercept four Bf 109s which strafed the airfield, damaging a Hurricane of 238 Squadron. On return to the field Sgt Elliott suddenly dived from 10,000 feet and crashed, being killed instantly. He was not seen to be shot down and no cause for his ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("death could be ascertained. During the afternoon Messerschmitts of I./JG 27 on a Freie Jagd patrol intercepted and shot down a Wellington of 38 Squadron and an Albacore of 826 Squadron which were preparing for a night operation. Full details of these engagements may be found in ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("In the foreground is the tail of a Cant.Z.1007bis, the main bomber type employed by the Regia Aeronautica during 1942. Behind is a Bf 110 of III./ZG26.")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_46.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 10 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the very early hours Plt Off Fraser and Sgt Sands of 73 Squadron flew to El Adem to undertake a night strafing sortie from there. However, Fraser was unable to take off again, so Sands went alone. During this sortie he was hit by ground fire and caused to bale out. This he achieved safely, returning to the unit three days later.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During another Freie Jagd operation, two pilots of I./JG 27 intercepted and shot down a bomber when east of Sidi Barrani, identified as a Boston. However, this may in fact have been a Beaufort of 39 Squadron since no Boston losses were recorded. On the other hand a Ju 88 of 3./LG 1 flown by Oblt Iro Ilk, also engaged a British bomber, in this case identified as a Blenheim, the German crew claiming to have shot this down north of Derna. Again, more details of this engagement will be found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was on this date that Sqn Ldr C.R.Caldwell of 112 Squadron heralded a new form of operation for the Kittyhawk units when he made the first test drop of a 250lb bomb from one of these fighters. Now re-equipped and fully converted to these aircraft, 260 Squadron moved to Gasr el Arid, bringing the number of Kittyhawk units at the front to four, supported by two more with Tomahawks.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Regia Aeronautica’s 5"), _c('sup', [_vm._v("a")]), _vm._v(" Squadra HQ received a visit on this date from Gen SA Rino Corso Fougier, Regia Aeronautica chief of staff. He would undertake a tour of the main Italian fighter bases during the next few days. The date of his visit coincided with the return to Italy of all S.81s of 103"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia of the Aviazione Sahariana; they would be replaced by Ghiblis. That night two BR.20s of 43° Gruppo bombed Tobruk.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Lt Friedrich Körner of 2./JG 27 claimed his 10th victory on 9 March.")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_48.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 11 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Next morning 4 SAAF Squadron joined 260 Squadron at Gasr el Arid, but the main activities of the day occurred during escort missions over a convoy making for Tobruk. Here three sections of Tomahawks from 5 SAAF Squadron patrolled north of Gambut, Capt Hewitson sending a Ju 88 of 12./LG 1 crashing into the sea at 1600, with a second bomber claimed as a probable a couple of hours later. It appears that one of the patrols was intercepted by MC.202s, six of these fighters from 79"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia undertaking a "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("reconnaissance mission off Tobruk at much the same time in the morning. During this mission S.Ten Alessandro Rosa reported seeing two fighters at lower level, bouncing these and claiming damage to both. Although the times and location coincide, no such engagement was recorded by the South African unit.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_49.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 12 March 1942")])]), _vm._v(" "), _c('div', {
    staticClass: "fig2"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_50.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 13 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At midday five Hurricanes of 274 Squadron and 12 Kittyhawks of 112 Squadron took off to intercept an incoming raid in the Tobruk area. Flg Off Bartle and Sgt Rozanski of the latter unit were bounced by Bf 109s diving out of heavy cloud, and Obfw Schulz shot down Rozanski’s aircraft, the Polish pilot belly-landing and climbing out of his aircraft just before it burst into flames. Sgt Burney claimed to have attacked and destroyed an MC.202; Sgt Dodds of 274 Squadron reported that he had spotted three Ju 87s escorted by two MC.200s, one of which he climbed after and attacked. He claimed that this crashed on its back 20 miles west of Tobruk.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_51.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 14 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Twelve Kittyhawks each from 450 and 3 RAAF Squadrons escorted 12 Bostons to bomb Martuba, while 12 more Kittyhawks of 112 Squadron flew a diversionary sweep in the area. As they approached, seven MC.202s of 6° Gruppo were scrambled from Martuba at 1310, led by Cap Dante Ocarso to intercept the formation which was appearing over their base. They pursued with some success, claiming eight P-40s shot down and others damaged, including one of the Bostons. Cap Ocarso himself claimed two P-40s and Serg Magg Borreo claimed three.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("112 Squadron had arrived as the dogfight was taking place and dived straight in, claiming two fighters shot down but losing two of their own in doing so, Sgt Simonsen being shot down in flames as Sgt Evans baled out. Meanwhile, two of 450 Squadron’s aircraft were damaged, although the pilots managed to get back to base. As often happened, the Macchis were identified as Messerschmitts by several pilots, but 3 ")]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("RAAF Squadron could claim only one aircraft shot down, plus two probables, while 450 Squadron made no claims at all. During this raid the bombing damaged four German aircraft, including three Bf 109s. On this date 2.(H)/14 lost a Bf 109E shot down by Curtiss fighters and crashed near Tobruk. This may have been the subject of one of the claims for such an aircraft – possibly that of the 112 Squadron pilots.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("At 1700 16 150° Gruppo MC.200s and 16 MC.202s of 6° Gruppo raided a large concentration of armoured cars south of Ain el Gazala, claiming ten destroyed and many damaged, but lost three MC.200s to AA. One fell in flames in the target area, Serg Magg Zandonai being killed, a second crash-landed at Martuba, the pilot of this also losing his life, and the third force-landed within Axis lines.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_52.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 15 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("450 Squadron again despatched 12 Kittyhawks to escort Bostons to Martuba, this time accompanied by 260 Squadron, as 12 Tomahawks of 2 SAAF Squadron flew a diversionary sweep. Bf 109s of II./JG 27 and six MC.202s of 6° Gruppo, led by Magg Marco Larcher, took off to intercept, the Italian pilots claiming four P-40s shot down near Martuba, with Obfw Woidich and Schulz each claiming one in the Gazala-Acroma area. Cap Giuseppe Pesola of 79"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia attacked four fighters but was unable to observe the results; he was then attacked by a Kittyhawk that badly damaged the radiator of his aircraft. Pesola managed to escape his adversary by flying over the sea at very low altitude, but after a few minutes he was forced to head for the coast to try and belly-land. Once landed, still within British lines, he quickly abandoned his Macchi, looking for a place to hide. He spent the night hidden among the beach dunes, but next morning was taken prisoner by a South African patrol, alerted by some Arabs. Taken to Camp 310 near Suez, he managed to escape three months later but, after more than one year spent in Egypt on the run, he was again captured and taken to Camp 304 at Helwan. He would return to Italy after the armistice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pilots of 3 RAAF Squadron claimed two fighters probably shot down, but 2 SAAF Squadron had two Tomahawks damaged, 260 Squadron one Kittyhawk and 450 Squadron one more. The South African unit recorded that its pilots appeared to have panicked slightly when attacked, and their formation broke up in confusion.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_53.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Cap Giuseppe Pesola prepares to climb into his MC.202 ‘79-5’ MM 7885. This pilot was forced to land in Allied-held territory on 15 March and became a prisoner of war.")])])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("2 SAAF Squadron was up again in the afternoon on an interception scramble over Tobruk, during which one claim was made for a Bf 109 and one for a damaged. Lt Isaacs, who made the latter claim, then had his own aircraft slightly damaged. The claim for the Messerschmitt shot down – the only confirmed claim of the day – may relate to Pesola’s MC.202 which belly-landed within British lines. However, it was reported that Sgt Taylor of 450 Squadron in Kittyhawk AR706 AK-X, noted: “knocked hell out of a 109F and tried to get it confirmed later – was.” Evidence that this was the case has not been discovered. This was the last combat in which Obfw Otto Schulz would take part for several weeks as he was now sent home to Germany on leave, which was to be followed by an officer’s course.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Sgt Joe Bernier sits on the tail of a 260 Squadron Kittyhawk which had been shot-up by a Bf 109 of III./JG 27 on 15 March, the pilot (Sgt T.‘Polly’ Parrott) being wounded. Note that at this stage the unit’s aircraft carried the codes MF, soon to be changed to HS.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the night a bombing raid on Martuba seriously impaired 150° Gruppo’s aircraft serviceability as at least four MC.200s were destroyed and some others damaged. On this date as well, a communications Bf 108 of StG 3 was destroyed.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_55.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_56.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 16 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("17° Gruppo moved from Benghazi K3 to Martuba with 16 serviceable MC.202s, bringing the whole 1° Stormo together at this base. On this date, however, 209"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia BaT was ordered to fly its Ju 87s home to Italy.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("208 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane Z4798 left 0945, lost propeller and crash-landed in Mechili area; 2/Lt J.W.F.Somerville in desert two days and nights before being picked up safely")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("4 SAAF Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Tomahawk IIb bombed on ground by two Bf 109s and damaged")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("14 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Blenheim IV V5446 ‘M’ force-landed on road Agedabia-Agheila for unknown reason. Crew walked for nine days until picked up by British armoured unit. Sqn Ldr A.C.Mills and two safe")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 17 March 1942")])]), _vm._v(" "), _c('div', {
    staticClass: "fig2"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_57.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 18 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This was a mystery day. Luftwaffe reports indicate that 14 bombers and eight fighters attacked Martuba, damaging some Bf 109s on the ground. The groundcrews of the alert Schwarme kept working on their aircraft during the attack, suffering sprained hands and feet from the blast of the bomb explosions. II./JG 27 reported attacking British fighters over Gazala and Tobruk, claiming four victories against P-40s, one of which was not confirmed. However, during this fight an aircraft of 8.Staffel was shot down in combat with bombers, the pilot becoming a PoW. One claim for a Bf 109 damaged was made at this time in the Martuba area by a pilot of 260 Squadron, but no other details of this day’s action have been found in British records.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("It had been a week of sustained action for the Boston crews of 3 SAAF Wing, which undertook daily attacks on the Axis airfields as a diversion while a convoy for Malta was to be fought through from Alexandria from the 20th. Starting on 14 March the Bostons had been much involved. The raid undertaken on the 15th had been classed as ‘quite exceptional’, although the next day’s attack had been all but aborted due to bad weather. A full-scale attack by 12 SAAF Squadron had been made on Martuba on the 17th, but now came the operation of 18 March. Bursts of heavy Flak were experienced and Axis ")]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("fighters were seen climbing upwards, while during the return flight the bombers were fired on by ‘friendly’ Bofors guns – but no losses or serious damage was noted, and of the escorting fighters there was no mention!")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_58.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 19 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Martuba East was again the target for 3 SAAF Wing, but once more the Bostons were fired on by 8th Army Bofors as they returned. During the morning 80 and 2 SAAF Squadrons were scrambled on an interception patrol over the Gambut area around 1030. One Bf 109 was claimed shot down and one probable, but one Hurricane was shot down into the sea and others were damaged.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At 1245 11 MC.202s of 6° Gruppo were scrambled over the Martuba area, led by Magg Larcher to intercept the Bostons’ raid, but only two pilots managed to get within range, claiming one fighter shot down and one damaged. Some considerable time later a further victory was claimed by Uffz Niederhöfer of II./JG 27. At 1500 two pilots of 80 Squadron took off for a weather reconnaissance to the Gulf of Bomba, but they were intercepted by four Bf 109s. Flt Lt Trollip went into a spin to evade them, subsequently recovering and returning to base at 1550. Sgt Smith’s aircraft, however, was badly damaged and he landed at Tobruk. The times recorded indicate that his was probably the aircraft claimed by Niederhöfer. Once more all the four fighters claimed by the Axis fighters during the day were listed as P-40s but all the British losses were Hurricanes.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_59.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Oberfahnrich Willi Kientsch, serving as a young cadet with Stab II./JG 27, would remain active in the Mediterranean area for many months with this Gruppe.")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_60.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Bf 109Fs of II./JG 27 at Martuba in early 1942.")])])])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_61.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 20 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The 3 SAAF Wing raid went in early, 260 Squadron being amongst the fighter units providing escort. Bf 109s of I./JG 27 were scrambled, as were six MC.202s of 17° Gruppo. The German pilots claimed three Curtiss fighters shot down without loss, but amongst the Italians claims could only be made for one fighter and one bomber damaged. However, Serg Magg Remo Broilo failed to return, but survived and was back at Martuba two days later. He reported that he had become engaged with five P-40s and had managed to shoot down two of these before his Macchi was hit and set on fire, and he was slightly wounded. He then managed to bale out into no mans’ land from where he was rescued by a German patrol.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("260 Squadron’s Kittyhawks had been heavily involved, two pilots being shot down near Gazala, one of whom crash-landed at Tobruk. Meanwhile Flt Sgt Hindle’s aircraft was damaged as was Sgt Wareham’s. Flt Sgt Willmott was attacked by a reported four Bf 109s, one of which he claimed to have shot down, seeing this crash-land (this may have been Broilo’s Macchi), following which he and Hindle landed at El Adem.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("3 SAAF Wing recorded that the bomber crews had noted the aircraft on the ground at Martuba to have been well dispersed, with ground fire heavier than ever. Nonetheless, their bombs had destroyed a TacR Bf 109E for the second day running. The wing noted with satisfaction that although some of the escorting RAF fighters had suffered some losses, they had beaten off all attacks on the Bostons.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_62.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_63.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 21 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("By morning on this date the convoy for Malta had reached the eastern end of ‘Bomb Alley’, the passage between Crete and Cyrenaica, the scene of heavy attacks during previous convoys. Eighth Army had taken part in providing diversions, 50th Division, 1st South African Division and the Free French Brigade having launched raids which drew off the air forces. Admiral Cunningham attributed the success of the convoy to have been largely achieved as a result of these diversions. The main ground column got close enough to Martuba and Tmimi to shell the airfields here and as a result was heavily attacked from the air, although 120 Axis troops were taken prisoner. While these attacks were underway, 3 SAAF Wing was ordered to raid further west at Barce. Lt Col J.A.Mossop, commander of 24 SAAF Squadron, led the first such attack by four Bostons, bombing through heavy cloud and destroying a BR.20 bomber of 4"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia, 11° Gruppo, on the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Because of the intensity of the action, 94 Squadron had been called back onto operations, now sending out sections of four Kittyhawks at 20-minute intervals to patrol over the Gazala-Tobruk area. The second such flight encountered six Bf 109s of I./JG 27 over the sea north of Gazala, one Kittyhawk being shot down and a second damaged. A Schwarm of Bf 109s from I./JG 27 had been sent back to Derna early in the morning in order to be able to intercept the first bombing raid of the day and two of these, flown by Lts Körner and von Lieres, intercepted the 24 SAAF Squadron formation led by Lt Col Mossop. Once clear of the coastal cloud, Mossop had led his bombers down to about 100 feet above the ground. Having made their attacks, the bombers were on their way back to base and were flying well to the south of Bir Hacheim when Flt Sgt van Eyssen gave the warning: “Three enemy fighters at 200 feet.” Reportedly, their attackers comprised two Messerschmitts and one MC.200, the latter turning away as soon as the Bostons’ guns opened up. The South Africans had thought that fighters would not attack them at such a low level, or even if they did, would only make a single pass. They were sadly disillusioned as the two Germans continued maintaining a running attack. Capt J.P.Verster, who had only been in Egypt for 11 days and who was on his first operational flight, had the starboard engine of his aircraft shot out and Air Sgt F.A.J.Bender, his rear gunner, killed. A second attack hit the remaining engine and Verster made a high speed crash-landing. As he and the rest of the crew climbed out of the burning aircraft, the Messerschmitt roared past, continuing to fire at the wreck.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile, Mossop’s aircraft was also under attack and was being hit. Part of the tail was shot away and the fuselage was filled with the cordite of the exploding cannon shells. Both Mossop and Flt Sgt van Eyssen suffered broken legs; the rear gunner, Air Sgt R.E.M.Hague, had been half knocked out by the explosion of a shell close to his head. As Mossop attempted to keep control, the Messerschmitt attacked again, hitting the fuselage and the starboard engine. He managed to throttle back and like Verster, made a belly-landing. Plt Off B.A.Colebourne, an RAAF observer attached to the squadron, and Hague between them got the wounded top gunner out of the aircraft. Mossop was thus alone in the aircraft when during a further pass, a cannon shell pierced the rear seat armour, “blowing a fearsome hole in his back” as a broken oil lead sprayed over the engine. The other members of the crew got him out just before the petrol tank blew up, at which point Körner and von Lieres departed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After Mossop’s wounds had been dressed, Colebourne set off on foot to seek help. He found no-one at the site of Verster’s crash since the crew had already set off on a two-day walk to safety. At Mossop’s aircraft, the pilot held on, gravely wounded, in the hope and belief that the observers in the other Bostons would have maintained a note of their route and position to allow rescue to be organised. In fact they had not done so, and this considerably delayed any rescue. However, Colebourne walked for two days and nights by which time his flying boots were worn through and his feet lacerated, but reached Allied-held territory. The positional information he provided made it at last possible to send out a Lysander under the protection of a fighter patrol, a doctor that this aircraft was carrying providing treatment until an air ambulance aircraft could arrive and evacuate Mossop and the other wounded crewman. Jack Mossop subsequently recovered to lead 3 SAAF Wing in Italy many months later. Colebourne, after a long spell in hospital, was awarded a MBE. Meanwhile, Lt Körner’s claim was recorded as I./JG 27’s 1,000th of the war, which was celebrated in the proper fashion.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Meanwhile, during the day the well-camouflaged British column had approached Martuba airfield and at midday commenced shelling. The airfield staff at once began a defensive action and an emergency ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("call was sent for 88mm guns. Unwisely, the British troops had taken up positions on a slope "), _c('i', [_vm._v("towards")]), _vm._v(" the airfield instead of on the reverse side, thereby leaving themselves exposed to counter-attack. Stukas arrived and took part in strafing attacks, joined by every available fighter.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The vehicles accompanying the column had initially been spotted approaching the airfield by a pair of MC.202 pilots of 17° Gruppo who were undertaking a tactical reconnaissance sortie at 1300. Within half an hour six more Macchis from 6° Gruppo led by Cap Domenico Camarda, took off to strafe, claiming to have left three vehicles in flames. Fifteen more 1° Stormo MC.202s followed at 1350 (eight of 17° and seven of 6° Gruppi) and led by Cap Guido Beggiato, took up the attack, reporting 11 vehicles in flames and many others damaged. One Macchi was hit by AA and crashed in flames. No more losses were suffered as further attacks were undertaken. The MC.200s of 150° Gruppo also took part, ten of these aircraft strafing vehicles south of Martuba between 1440-1515.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After about 30 minutes 88mm guns arrived and a battle lasting some six hours ensued. In the evening tanks and motorized infantry reached Martuba, and sallying out, brought back a number of prisoners. Later in the day Cap Camarda led eight MC.202s to Barce to protect that airfield from further attack. At the end of the day Gen Hans-Ferdinand Geisler called Col Alfredo Reglieri, 1 ° Stormo’s commander, to congratulate him on the effectiveness of the Italian attacks. Also, 1° Stormo now received 13 new MC.202s directly from Italy, increasing the unit’s serviceability to about 40 fighters.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Regia Aeronautica did suffer further loss during the day, however, when an SAS raid by night on Benghazi led by the redoubtable ‘Paddy’ Mayne, destroyed a Ca. 133 and two CR.42s, severely damaging four more of the biplane fighter-bombers. This had the result of increasing the protection of Axis airfields against further such commando raids.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elsewhere during the day 2 SAAF Squadron flew patrols over the Tobruk-Gazala area on one of which its Tomahawks were bounced by fighters while returning to base, one pilot having to force-land near the airfield with the side of the cockpit partly shot away. A Hurricane of 40 SAAF Squadron was also lost during a TacR sortie. In the evening Hurricanes of 274 Squadron flew close escort to Bostons raiding Martuba again, one of the fighters being shot down in flames by Flak. Meanwhile, 3 RAAF Squadron had spent the day away from the battle zone, flying patrols over the Malta convoy, their aircraft fitted with long-range tanks.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_64.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_65.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 22 March 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("Following an uneventful night around Martuba three MC.202s of 81"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia led by Cap Giuliano Giacomelli, undertook an early reconnaissance but saw no movement of British vehicles. The sortie was repeated at 0730 by Ten Luigi Zamana, but again nothing was to be seen. German fighters later attacked the remaining forces, now in retreat, destroying most of their surviving vehicles. What became known to JG 27 as ‘The Battle of Martuba’ was at an end. Following these actions the Malta convoy – MW10 – at last came under sustained air attack, as recorded in ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("3"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 43°Gr, 13°St BT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("BR.20 MM 22709 crashed near Barce; pilot Ten Aldo Nebbiolo and three WiA, copilot Serg Virgilio Guicciardi died of injuries")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 23 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Martuba West was again the target for 24 SAAF Squadron during the morning, 94 and 260 Squadrons providing the escort on this occasion, but the defences were ready for them. The 12 Bostons approached from over the sea, flying into a veritable hurricane of Flak, as Messerschmitts from III./JG 27 and ten Macchis of 1° Stormo were scrambled to intercept. The Boston flown by Maj Ritchie Tennant was seen to lurch out of control and go down in flames with the loss of the crew. Lt Steyn lost control of his bomber as it was buffeted by shell bursts, and he ordered his crew to bale out. However, the intercom system had been damaged and only one man, Lt J.H.O.Dellow, heard him and got out. He reported: “As I went floating down I saw him fight the aircraft into level flight and escape.” Realising that the others were still on board and despite 70 splinter holes in his Boston, Steyn sat back into his cockpit, evaded an attack by a lone fighter, and crash-landed near Tobruk. Whilst he was doing so, his gunner, Sgt S.F.Oostheuizen, claimed to have shot down one Messerschmitt in flames.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A third Boston, flown by Lt P.O’Donovan, was hit and set on fire by Flak, but the pilot kept the aircraft steady until the bombs had been released. With the gunner wounded, he then crash-landed near Sidi Rezegh, the crew all escaping. Sgt G.Catchlove, the gunner and a member of the RAAF, was wounded while fighting off one of the attacking fighters. A fourth bomber, also hit by ground fire, was attacked repeatedly by fighters, Lt Elliot-Wilson crash-landing this aircraft at El Baheira. The remaining bombers held formation as their escorts engaged the Axis fighters, the gunners in two of them claiming to have shot down one attacker by the cross-fire between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Amongst the Kittyhawks, each squadron lost one aircraft, 94 Squadron claiming two Bf 109s shot down and a third damaged in return. Luftwaffe pilots claimed two P-40s and one Boston shot down with two more Bostons claimed by the Flak gunners. One Messerschmitt force-landed at Martuba 85% destroyed in the combat, but the pilot escaped unscathed. The Italian pilots claimed a further three P-40s shot down and three probables, plus a Boston damaged; they suffered no loss or damage. One more JG 27 Messerschmitt was badly damaged on the ground during the bombing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As a result of this series of raids, 24 SAAF Squadron had now lost both the commanding officer and his deputy, Maj Tennant. Maj C.Gey van Pittius took over on an acting basis until Lt Col J.A.Rademan, DFC, could arrive from the Union to assume command.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_66.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_67.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 24 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In very bad weather an MC.200 of 8° Gruppo crashed when patrolling over Benghazi harbour with the loss of the pilot. The reason for his demise was not discovered. The pilot was killed and his MC.200 destroyed.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("92"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 8°Gr, 2°St CT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("MC.200 MM 5902 crashed to ground for u/k cause at Benghazi, Serg Magg Vito Copersino KiFA")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 26 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Early in the afternoon Hurricanes of 80 Squadron were scrambled over Tobruk, encountering Bf 109s of III./JG 27. Flg Off Frank Mason claimed one of these probably shot down, but his own aircraft was badly damaged by Fw Waibel, who claimed to have shot it down. Reportedly, Mason’s Hurricane was also hit by the ‘friendly’ AA from within Tobruk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Later on that same afternoon nine Kittyhawks of 94 Squadron provided close cover to nine Bostons of 12 SAAF Squadron, which had now relieved the hard-hit 24 SAAF, while 12 more fighters of 260 Squadron formed the top cover. Five MC.202s of 17° Gruppo were scrambled, followed some minutes later by ten more from 6° Gruppo; Bf 109s of III./JG 27 also took off. Four of the latter attacked the escort all the way back to Tobruk, shooting down one 94 Squadron aircraft and badly damaging a second – the German pilots claiming both on this occasion. This time the Italian pilots were able only to claim a P-40 as a probable and a second damaged. Three of the Bostons were hit by Flak, but all returned safely.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An S.79 of 174"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia RST took off from Benghazi at 1320 on a reconnaissance mission to the Bir Tengender area, but failed to return.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_68.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_69.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 27 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("274 and 450 Squadrons took off on a morning interception sortie over Tobruk and El Adem, but four of the 12 Hurricanes of the former unit were forced to return early due to engine troubles. Five MC.202s of 17° Gruppo had also scrambled to intercept bombers and fighters reported to be raiding Martuba again. They were joined 15 minutes later by four 6° Gruppo aircraft. Over Tobruk two pilots from the latter unit engaged fighters to the east which they identified as Spitfires, each claiming one of these shot down. They had obviously in fact engaged 274 Squadron’s Hurricanes, the pilot of this unit reporting being attacked from above by MC.202s, one of which was claimed shot down by Plt Off Conrad and one probably so by Sgt Barwick. The latter pilot, however, crash-landed at Bir Saliema when his Hurricane was hit and badly damaged. After the initial clash, S.Ten Sparapani reported that they had a second engagement as they headed for home, this time with P-40s, when S.Ten Rosa disappeared – he had actually crash-landed his Macchi and become a PoW. There were no claims by Kittyhawk pilots at this time, and it is likely that the Italian pilots had again been involved with 274 Squadron and that Rosa’s aircraft had fallen victim to Wally Conrad. Taken to Camp 310, Rosa met there Cap Pesola, captured on 16 March, and shared all his adventures, escaping and being re-captured after one year on the run in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At 1645 Hurricanes of 80 Squadron and Tomahawks of 2 SAAF Squadron were scrambled over Tobruk to intercept 15 Ju 87s of I./StG 3 escorted by ten Bf 109s. Lt Lipawsky claimed one of the Stukas probably destroyed, and it appears that he had damaged the aircraft of the Staffelkapitän of 3./StG 3, Ritterkreuzträger Hptm Helmut Naumann, who was wounded in combat with Curtiss fighters but managed to get back to base with his aircraft 10% damaged. A second Stuka was damaged to the same extent by AA. Meanwhile Lipawsky was then shot down and crash-landed, suffering wounds; his aircraft was strafed on the ground and burnt out. A second Tomahawk, flown by Lt E.Smith, was also shot down and crash-landed, it too being strafed as it did so, but Smith escaped unhurt. A third of this unit’s aircraft suffered minor damage.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Flt Sgt Comfort of 80 Squadron was also attacked by a Bf 109, his Hurricane being badly damaged. During this engagement, Oblt Franzisket of 1./JG 27 claimed one P-40 at 1655, while in the later stages of the fight three more were claimed by pilots of II./JG 27, two of them by Oblt Rödel.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On this date 250 Squadron became the sixth WDAF unit to convert to Kittyhawks, these aircraft replacing the unit’s Tomahawks.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_70.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_71.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 28 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Nine Kittyhawks of 94 Squadron provided middle cover to the Bostons on a raid at 1245, 12 more of 450 Squadron flying top cover with the Tomahawks of 2 SAAF Squadron as close escort. Three MC.200s of 150° Gruppo were being led by S.Ten Giovanni Dell’Innocenti and were on patrol over Martuba as the raid approached. They immediately engaged but one of these fighters was at once shot down and the pilot killed. Eleven MC.202s of 17° Gruppo and three of 6° Gruppo were then scrambled to pursue the raiders, claiming two P-40s shot down, plus three and one Boston damaged. One more fighter was claimed by Fw Steinhausen of 1./JG 27. However, one Bf 109 of this unit was hit in the engine by one of the Curtiss fighters and crash-landed at Tmimi, 95% destroyed, although the pilot was not hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During this fight Plt Off Crosbie of 94 Squadron was shot down, and Sgt Halliday of 450 Squadron was also hit, force-landing just west of the front line, suffering wounds; he was picked up by an army unit. So too was Crosbie, whose unit was advised that he was in a field hospital, only slightly wounded. However, on 5 April came the news that he had died.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Despite the losses of one Messerschmitt and one MC.200, the only claims to be submitted on this occasion were made by 450 Squadron and were for three Bf 109s as probables and one damaged. The bombing on this date had resulted in considerable damage when an ammunition dump was hit and exploded, destroying three Bf 109s of JG 27 and damaging three more. Another Messerschmitt was lost when the 4.Staffel aircraft flown by Lt Endmann was shot down by AA 20km west of Gazala; Endmann was seen to bale out but failed to return.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_72.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_73.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday-Monday, 29/30 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the night 19 CR.42s of 3° Gruppo led by Cap Giuseppe Tovazzi raided Tobruk harbour and vehicle concentrations along Via Balbia, reporting hits on the docks and many lorries left in flames.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 30 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Hurricanes of 1 SAAF Squadron were again engaged in a convoy patrol, this time from LG.110, when they intercepted and shot down a bomber, identified this time as a Ju 88. It proved to have been a Blenheim of 14 Squadron which crashed into the sea near Ras el Rumb with the loss of the crew.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_74.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_75.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("A CR.42 of 3° Gruppo carries the unit’s ‘red devil’ insignia on the wheel spat. On the right is Cap Giuseppe Tovazzi, commanding officer of 154 Squadriglia, who failed to return from a strafing sortie on 28 May. ("), _c('i', [_vm._v("Gatti")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 31 March 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the day 2 SAAF Squadron flight tested all its aircraft prior to undertaking a mission. As Lt Hopkins returned from one such sortie at 0800, his aircraft was suddenly bounced by a Bf 109 of III./JG 27 out on a Freie Jagd, and was shot down, the pilot being killed. The German fighters at Martuba received a visit on this date from General Rommel.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_76.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 1 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On a TacR sortie a Hurricane of 40 SAAF Squadron was hit by Flak, force-landing. 33 Squadron moved to Gambut. 133° Gruppo AS was formed at Benghazi K2. It was created when the reconnaissance unit, 174"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia RST, changed its role to that of torpedo-bombing and joined with 175"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia, which was based at Tripoli. 5"), _c('sup', [_vm._v("a")]), _vm._v(" Squadra assumed command of the Aviazione Sahariana and all reconnaissance units formerly under army control.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("40 SAAF")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane hit by AA force-landed between lines, rescued by army who destroyed the aircraft; Lt W.J.A.Webb safe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("80 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane IIc BE706 left 1610, spun in, no one saw what happened; Flt Sgt A.D.Nightingale MiA")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 2 April 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Eleven MC.202s of 17° Gruppo were off at 1105 to escort seven MC.200s of 150° Gruppo to Tengender on a strafing mission. One MC.200 was hit and damaged. In the early afternoon four Bf 109s of I./JG 27 on a Freie Jagd attacked four Hurricanes of 238 Squadron patrolling over nine ships, claiming two shot down. Only one was recorded as lost when Sgt Cartwright’s aircraft crashed straight into the sea. Plt Off Milne claimed to have damaged one of the Messerschmitts, and it seems that this was the aircraft ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("flown by Lt Willi Kothmann, one of those who were thought to have shot down the Hurricanes, for this 13-victory ace failed to return after his aircraft was hit in the cooling system and was subsequently seen to crash into the sea 30km north of Marsa Luch.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("At 1725 eight Bf 109s of I./JG 27 with belly tanks fitted, eight of II.Gruppe and 15 of III.Gruppe escorted 12 Ju 87s of I./StG 3 to attack shipping near Tobruk. Ten Kittyhawks of 260 Squadron and a number of 80 and 238 Squadron Hurricanes were scrambled to intercept north-west of Tobruk. 80 Squadron was attacked by I.Gruppe which was forming the top cover, and two of the unit’s Hurricanes were shot down.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("238 and 260 Squadrons attacked the Stukas, between them claiming one shot down and two damaged, the Kittyhawk pilots also claiming damage to three fighters, two of which were thought to be MC.202s. On this occasion two Ju 87s were actually shot down, both coming down in the sea about 20km northwest of Tobruk. III./JG 27 claimed one P-40 shot down, while Uffz Monska of II.Gruppe claimed to have caused one fighter to crash-land, although this was not confirmed due to lack of witnesses and there appeared to be no corroboratory evidence. In fact 260 Squadron lost one aircraft and its pilot. During the fight one of the Messerschmitts of III.Gruppe was hit by AA and force-landed near El Adem.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The final engagement of the day was subsequently recorded by 2 SAAF Squadron on the wrong day (4 April) – and with some uncertainty regarding the classification of the claims or the identity of the opponents claimed. At 1835 Wg Cdr Beresford, the new wing leader of 233 Wing led eight Tomahawks on a scramble over the Tobruk-Gazala area, encountering 15-20 fighters variously identified as Bf 109s or MC.202s; there was some debate regarding this on the unit’s return to base. Beresford claimed one shot down as it was attacking Lt de Villiers, though it may have been classified as a probable. De Villiers and Lt Higgo shared in damaging another – although it is possible that they shared with Beresford. Meanwhile, Lt Eric Saville hit one that was last seen losing height and speed, then attacking another that was seen going down very fast, and then damaged a third. The squadron operations record book seems to credit Beresford with one MC.202 and Saville with two and one damaged – but in either case the credits could have been as probables. However, the authors have stuck with the ORB since this accords with the total number of victories Saville had achieved according to the citation when he was awarded a DFC in September.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_77.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_78.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 3 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the morning eight Kittyhawks of 260 Squadron and ten of 94 Squadron escorted Bostons to Derna. Here Plt Off Usher of 94 Squadron claimed a Bf 109 shot down east of the town. This appears to have been I./JG 27’s Lt Julius Wildau who crashed near the Via Balbia following an engagement with P-40s, and was killed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Flying a diversionary sweep at this time, 274 Squadron’s eight Hurricanes also encountered Messerschmitts which shot down one Hurricane in flames, the pilot of which was killed. The other pilots claimed two Bf 109s and an MC.202 probably shot down. The Axis fighters then met 260 Squadron over Bomba Bay, this unit’s pilots claiming two Bf 109s shot down and a Macchi probable. 94 Squadron was in action in the same area, losing two of its aircraft at this time. 450 Squadron was also engaged, claiming damage to three Macchis.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During this series of engagements, Luftwaffe claims amounted to three P-40s, with a fourth claimed by Uffz Schwekusch as having belly-landed; again, this was not confirmed due to lack of witnesses. Apart from the loss of Wildau, a second Messerschmitt was force-landed in Axis territory by Lt Rainer. Italian fighters had also been heavily involved, ten 6° Gruppo MC.202s having scrambled at 1015. These engaged P-40s over Ain el Gazala, and one was claimed as a probable. However, one Macchi was shot down and the pilot killed in the Bomba Bay area. Fifteen minutes behind them, 11 more Macchis of 17° Gruppo had followed, five of these engaging 12 Curtiss fighters, four of which were claimed shot down, plus one probable and one damaged. In summary therefore, two Kittyhawks and one Hurricane had been lost by WDAF against Axis claims for eight (five by Italian pilots and three by Germans); WDAF claims totalled three Bf 109s plus two and two MC.202s as probables, with actual Axis losses as one or two Bf 109s and one Macchi.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_79.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_80.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 4 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Two MC.202s undertook a reconnaissance over the Bir Amarin-Bir Tengender area during which one pilot force-landed due to a fuel leakage. He was rescued and the aircraft recovered. Late in the afternoon eleven 17° Gruppo Macchis provided cover for nine MC.200s of 150° Gruppo to strafe a column south of Bir Amarin. Seven vehicles were reported set on fire and 27 damaged. One MC.202 force-landed in the desert, the pilot returning on foot next day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the afternoon 450 Squadron lost two pilots in unusual circumstances. Six of the unit’s Kittyhawks were patrolling over Gambut at 6,000 feet when Plt Off Evatt lost control and went into a spin, followed a few minutes later by Plt Off Macpherson, both being killed. Both were new and inexperienced pilots, but no reasons could be found for their loss.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("80 Squadron’s commanding officer, Sqn Ldr J.R.Urwin-Mann, was posted away, tour-expired, command of the unit passing to Flt Lt C.R.A.Forsyth from 94 Squadron.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("153"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia of 3° Gruppo CT moved from Benghazi K2 to Martuba.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("6./JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Bf 109F-4 trop, combat, cabin hit by AA with minimal damage, but Uffz Otto Monska WiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("150° Gr CT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("MC.200 MM 5268 force-landed due to combat, Magg Antonio Vizzotto returned")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 5 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Early in the day six aircraft each from 94 and 4 SAAF Squadrons, plus four of 260 Squadron, undertook a wing sweep. Two Bf 109s of II./JG 27, returning from escorting a reconnaissance Bf 110, spotted the formation and attacked the 260 Squadron Kittyhawks. Flt Sgt Burrill’s blew up following Lt Jenisch’s attack, although the wounded pilot survived to bale out. A second Kittyhawk was also damaged. During the return flight a Ju 88 of 1. (F)/121 was seen over El Adem and this was shot down 30 miles south of Gasr el Arid by four pilots jointly. This was 4 SAAF Squadron’s first sortie since returning to the forward area.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_81.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_82.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 6 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On this date Axis forces began to move forward again, to consolidate their positions around Sidi Breghish and Segnali. This led to heavy fighting again. Early in the morning 12 Bostons set out to bomb Derna, escorted by 94, 2 SAAF and 4 SAAF Squadrons. Fifteen Bf 109s of I. and II./JG 27 took off to intercept, joined by 17 MC.202s of 1° Stormo (nine of 6° Gruppo and eight of 17°). The German pilots claimed three Curtiss fighters shot down but a further claim by Fw Heidel was not confirmed and may have been a double-claim on one by Lt Kalista. The Italian pilots claimed a further three P-40s, plus three damaged.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On this occasion the Axis pilots seem to have over-claimed fairly heavily, for the only loss by 233 Wing was the Kittyhawk flown by Flt Lt Shefford of 94 Squadron. Wg Cdr Beresford and Capt Bosman chased at least four Bf 109s off the tails of 4 SAAF Squadron, while Flt Lt Laubscher of 2 SAAF Squadron became separated and was repeatedly attacked on the way home, claiming one of his attackers shot down and one damaged. A further claim for a Bf 109 was made by Lt E.Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Charles Laubscher:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Squadron top cover to Bostons raiding Martuba. Three aircraft in my flight forced to return to base so I roved alone above squadron. Attacked on homeward run by a 109F, diving almost vertically, about five miles SE of Martuba. Turned tightly to port in standard evasive action. Saw him half-roll on to his back which enabled him to lay off a deflection. Pulled on my stick to tighten my turn and promptly my Tomahawk went into a spin. Straightened out at approx. 5,000 ft and found myself in a hornets’ nest of 109Fs all flying in sections of three line-astern at different altitudes. Saw that one section would pass almost directly ahead of me at a range of approx. 250 yards and laid off a full beam deflection on their No.3. Fired a long burst. His port wing dropped and he slid into a gentle dive. Did not wait to see what happened to him but headed back to our lines at full throttle. Two 109Fs attacked but I out-turned them at about 300 feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Northwest of Gazala I saw that a section of three 109Fs, flying in echelon port were overhauling me and as I now guessed that two were almost certainly pilots in training, I did a steep turn to port back towards them and did a head-on attack on No.3. Fired a good burst into him as we closed without any return fire. Immediately did a steep turn to port and headed back to Gazala, ducking over the escarpment down to the level of the mud flats. Only two aircraft closed on me, now more appropriately in line-astern. Never saw what happened to their No.3. Waited until they were committed to a quarter stern attack from left then turned tightly towards them, at about fifty feet above the ground. They were obviously unable, or too nervous, to turn as tightly as I did at this almost zero altitude. As they overshot I again headed for our lines, which were now close, and they left me. I prayed that our army types would not be trigger happy but I was low enough for our chaps to see my roundels and no shots were fired. I thought that I could only claim a probable and a damaged but a telephone call was received from the Bomber Wing that a rear gunner had seen an aircraft go in south-east of Martuba. As no other aircraft had fired a shot, this was clearly my 109F.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Whilst the pursuit of the departing WDAF formation was still underway, Hptm Homuth of I.Gruppe spotted a TacR Hurricane of 40 SAAF Squadron north of Tmimi, which he shot down. It is possible that some of the 1° Stormo pilots were also involved, Cap Camarda claiming to have damaged a Hurricane. The reconnaissance pilot, Lt Egner, baled out and became a PoW. Meanwhile 274 Squadron was scrambled to ‘de-louse’ the returning formation, undertaking a sweep with 12 Hurricanes over Gazala. Here the pilots became involved in a general dogfight with Bf 109s and Macchis, claiming Italian fighters (identified as MC.200s) as a probable and a damaged, one claim being made for a Bf 109 by Sgt Eagle.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("More Regia Aeronautica reinforcements now reached North Africa, 86° Gruppo BT, led by T.Col Goffredo Marrama, arriving at Barce from Italy with 14 Cant.Z. 1007bis. The two Squadriglie were 190"), _c('sup', [_vm._v("a")]), _vm._v(" (Cap Leo Vecellio-Reane) and 191"), _c('sup', [_vm._v("a")]), _vm._v(" (Cap Aurelio Salvadori). 13° Gruppo CT headquarters moved to Benghazi K3 with 77"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia; 78"), _c('sup', [_vm._v("a")]), _vm._v(" and 82"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglie would follow later.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_83.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 7 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the morning nine Kittyhawks of 260 Squadron provided top cover to six Bostons attacking Axis vehicles. Over Gazala they were intercepted by four Bf 109s of I./JG 27 when one was shot down and one damaged. Later in the morning Hurricanes of 33 and 80 Squadrons carried out a de-lousing sweep over the Gazala area meeting Messerschmitts and Macchis, claiming one of the latter shot down and one damaged.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the afternoon Kittyhawks again escorted Bostons on a raid, this time with eight of 94 Squadron as top cover. One pilot was reported to have baled out due to engine failure, but the formation was then attacked by nine Bf 109s of II.Gruppe which shot the tail off Flg Off Thompson’s aircraft. He baled out, returning on foot next day. Pilots of the German unit claimed that from two of the aircraft they shot down the pilots baled out, while the third, claimed by Oblt Fluder, crashed. It therefore appears that Oblt Rödel and Obfw Kientsch double-claimed on Thompson’s aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the day III./JG 27 lost two aircraft when engaged in fighter-bomber (Jabo) sorties. One of these, flown by Oblt Tangerding, came down near Tmimi due to engine failure. The German fighters had been reinforced further by the arrival at Derna from Sicily the day before of 6./JG 3, led by Oblt Jürgen Waldhelm. This unit moved on to Martuba but on arrival here two aircraft crash-landed, both suffering 10% damage.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_84.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_85.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 9 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("176"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia RST was disbanded and its six Cant.Z.1107bis and their crews were assigned to the newly-arrived 86° Gruppo BT, three to each squadriglia.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the afternoon Lt Gouws of 40 SAAF Squadron undertaking a TacR sortie in a Tomahawk, was intercepted over the Chichiba-Ezzeiat area by two Bf 109s of II./JG 27 which were also engaged in a reconnaissance sortie. The South African was shot down by Oblt Rödel, belly-landing on fire south of Mteifel Chebir. Lt Blaauw of the same unit force-landed later in the day with engine trouble.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_86.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 10 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A further pilot of 40 SAAF Squadron failed to return from an afternoon TacR. The unit was equipped at this time with 19 Hurricanes and two Tomahawks, borrowed from 208 Squadron which was resting.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("40 SAAF Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane FTR from Eluet el Daba (believed to be Z4320); Lt J. W.van Niekerk MiA")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 11 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At 1000 I./JG 27 provided close cover and II.Gruppe direct cover to 18 Ju 87s of I./StG 3 to attack vehicles in the Sidi Mansur-Bir Habex area. They were joined by 13 MC.202s of 17° Gruppo, currently at almost full strength. Seven Tomahawks of 4 SAAF Squadron led by Maj Moodie dived in haphazardly after the Axis formation had been spotted. Only two returned, each pilot claiming to have damaged a Stuka. Two pilots were reported safe but slightly wounded, both having crash-landed, and Lt Duff-Richardson was reported to be in Tobruk hospital, badly wounded; he subsequently claimed to have shot down a Bf 109 and a Ju 87, and damaged two more of the dive-bombers. Of two more pilots there was no news. British Intelligence later reported that two Ju 87s and one Bf 109 had been seen to go down, but evidence does not support this. One Ju 87 was shot down, although reportedly by AA as well as fighters, crashing 25km northeast of Sidi Mansur, where it burst into flames on impact; four more were damaged. One Bf 109 of I./JG 27 ditched in the sea, 80-100km north of Derna, but this was due to engine failure. On this occasion Luftwaffe claims matched South African losses quite exactly, I.Gruppe claiming two and II.Gruppe four.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("From LG.13 1 SAAF Squadron was withdrawn eastwards for patrol duties over Port Said (see more in ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_87.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_88.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 13 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A small expedition was undertaken jointly by German and Italian forces to neutralize a British landing ground which had been spotted in the eastern Libyan desert. Two S.82s of 145° Gruppo T, escorted by six Bf 110s of 7./ZG 26, carried a group of 60 Italian airmen, carabineri and German sappers with five machine guns and an anti-tank gun, the whole force commanded by T.Col Dazio Gilardoni of 5"), _c('sup', [_vm._v("a")]), _vm._v(" Squadra Comando Est (Eastern Command). Taking off at 0735, the transport aircraft landed on the deserted landing ground, as did several of the Bf 110s, three of which remained airborne as cover. Dumps of fuel and lubricant were shot-up, and it was noted that the wrecks of four Blenheims were present. By 1000 the operation had been completed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At about this time nine MC.202s of 17° Gruppo which had taken off on a free sweep, encountered a formation of P-40s, two of which were claimed shot down. The Macchi flown by one of the claiming pilots was hit in the radiator and force-landed within Axis lines. Three more claims for aircraft damaged were also made by pilots of 2 SAAF Squadron who claimed an MC.202 damaged, while suffering no losses.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("260 and 4 SAAF Squadrons had just arrived at El Adem from where the latter unit put up four Tomahawks. Early in the afternoon six Bf 109s appeared, carrying bombs, and two, from 6./JG 3, providing escort. The first Jabo missed hitting anything, but the second released 12 small bombs which destroyed one of 260 Squadron’s Kittyhawks and damaged several South African Tomahawks of 40 SAAF Squadron, Sgt McKay of the former unit being wounded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The patrolling Tomahawks dived to the attack, Capt Harrison shooting down one of the escorting pair, then giving chase to a second Messerschmitt which also failed to return, crash-landing west of El Adem. The pilot turned up on foot a few days later. German records indicate that this aircraft was also shot down in combat with Curtiss fighters, although it does not seem to have been credited to Capt Harrison, but to AA.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_89.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_90.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 14 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I./JG 27 despatched two Bf 109s to attack vehicles and Bofors emplacements near Gadd el Ahmar during the morning but Uffz Grimm’s aircraft was hit by AA and he baled out to become a PoW.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_91.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("On 14 April AVM Arthur Coningham visited 112 Squadron at Sidi Haneish to present the unit with its badge, and to undertake an inspection. In front of two of the unit’s Kittyhawks he addresses the parade; he is flanked by the commanding officer, Sqn Ldr C.R.Caldwell (right).")])])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("1./JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Bf 109F-3 trop WNr 8737 White 5 shot down by AA SE Gadd el Ahmar; Uffz Josef Grimm baled, PoW")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("79"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 6°Gr, 1°St CT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("MC.202 MM 7776 ‘79-7’ damaged by bombs at Martuba")])])])])])])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('b', [_vm._v("Wednesday, 15 April 1942")])])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the evening 11 Kittyhawks of 260 Squadron were ordered off on an interception patrol, but were attacked by Bf 109s. Sgt Parrott’s aircraft was hit and damaged, causing him to force-land near El Gobi. I./JG 27 claimed one fighter damaged.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("260 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I shot down by Bf 109 nr Bir el Gobi; Sgt Parrott safe")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 16 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("250 Squadron, now fully re-equipped with Kittyhawks, moved to LG.12 at Sidi Haneish and 112 Squadron returned to Gambut Satellite. 40 SAAF squadron lost another Hurricane during a TacR, Lt Rose failing to return from a sortie to Gazala.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("40 SAAF Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane V7431 shot down by Flak on recce Gazala; Lt N.M. Rose MiA")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 18 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It was the anniversary of I./JG 27’s arrival in North Africa, and the Kommandeur, Maj Neumann, organised ‘Neumann’s Grosse Wüstenrummel’ (Neumann’s big desert revels). Some of the groundcrew presented Neumann with a spade made from the control column of a Hurricane he had shot down; the spade had a most significant part in desert life, known to the German pilots as the ‘Spatengang’ (literally, walk to relieve nature). During the day all members of the unit wore fancy dress which they had concocted, and many booths were set up, including ball and dice games, wheels of fortune, a merry-go-round and a miniature rifle range. One of the biggest attractions was ‘Maack’s Weltschau’, a ‘world show’ presented by Hptm Maack which included such wonders as ‘the wife behind the lattices of the harem’, etc. Neumann himself performed creditably as a magician. During the evening a large tent arranged as a casino was packed with guests from all branches of the Afrika Korps, and a musical variety show was laid on, Werner Schroer acting as master of ceremonies, broadcasting to outlying units over ‘Radio Martuba’. This was jammed by the British and another frequency was tried, but this too was jammed. However, the day was a great success and caused a big sensation, helping considerably for a while to conquer the lethargy and boredom of desert life.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_92.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Geschwader Kommodore of Stukageschwader 3, Oberstlt Walter Sigel, led the unit throughout 1942 from April onwards.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 20 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("80 Squadron carried out an early sweep over the Bir Hacheim-Tmimi area, Plt Off Foskett and Flt Sgt Campbell catching and shooting down a lone Bf 109E of 4.(H)/12 on a TacR 15 miles south-west of Bir Hacheim. This unit had replaced 2.(H)/14 for reconnaissance duties at this time.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("At 1055 14 Bf 109s of II./JG 27 set off on a Freie Jagd, eight of them encountering 33 Squadron which had been scrambled on patrol over Tobruk. Two of the Hurricanes were shot down, both pilots baling out, with two more force-landing. On this occasion the German pilots claimed only the first two aircraft ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("– identified yet again as P-40s! As this engagement was taking place, eight Kittyhawks of 260 Squadron provided top cover to Bostons on a raid. No Axis interceptors were met, but near El Adem whilst on the way to the target, Plt Off Black was obliged to bale out – reason unknown.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_93.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 21 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At dawn Flt Lt Scade of 73 Squadron intercepted a Ju 88 of I./LG 1, but defensive fire hit the glycol system of his Hurricane, causing him to force-land at El Gobi at once. 86° Gruppo BT detached a flight of four Cant.Z.1007bis to Derna’s El Fteiah airfield, to undertake strategic reconnaissance missions, mainly to the oases of Kufra, Gialo and Giarabub.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_94.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 22 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("24"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia of 68° Gruppo OA, equipped with Ca.311s, arrived at Misurata from Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("77"), _c('sup', [_vm._v("a")]), _vm._v(" and 82"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglie of 13° Gruppo moved from Benghazi to Martuba. 78"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia remained at Benghazi to provide harbour protection. During the day a Ghibli of 12"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia APC sighted a Blenheim IV abandoned deep in the desert (30°15’-21°40’) by its crew. The pilot landed nearby and set fire to the aircraft.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("33 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane IIb BG350 shot down by Flak; Flt Lt D.C.Cloete safe")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 23 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the day 250 Squadron moved up to Gambut to resume operations. A reconnaissance Bf 110 of 4.(H)/12 was shot down by AA at Bir el Chaualat with the loss of the crew. With evening four Cant.Z.1007bis of 191"), _c('sup', [_vm._v("a")]), _vm._v(" Sq took off at 1935 to bomb Tobruk. During taxying, one collided with a parked S.79, damaging a wing. Three reached the target and two released fragmentation and incendiary bombs. A fifth aircraft went up in flames during take-off and was completely destroyed, pilot Ten Vittorio Vinciguerra and his crew being badly burnt.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("4.(H)/12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Bf 110E-3 WNr 2525 shot down by AA Bir el Chaualat; Lt Josef Lengitz, Obfw Karl Hirschberger, Obgefr Wilhelm Hopfeld KiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("191"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 86°Gr, 35°St BT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Cant.Z. 1007bis MM 23418 destroyed by fire on taking off from Barce, pilot S.Ten Vittorio Vinciguerra, copilot Serg Lures Paltrinieri and observer S.Ten Antonio Desiderio wounded")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('b', [_vm._v("Italian Casualties")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("191"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 86°Gr, 35°St BT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Cant.Z. 1007bis MM 23415 damaged after collision in taxying, pilot T.Col Goffredo Marrama safe")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 24 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Early in the morning three 260 Squadron aircraft strafed four lorries west of Bir Hacheim, all of which blew up. Sgt Tregear failed to return and was thought to have flown into the explosion of his target and crashed. Eleven Tomahawks of 2 SAAF Squadron then carried out a sweep over the Bir Hacheim area where they were attacked by three Bf 109s. These comprised a pair of III./JG 27 aircraft and a Bf 109E of 4.(H)/12 which they were escorting. Lt E.Smith shot down the reconnaissance aircraft in flames, the two escorts being claimed hit by other pilots.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the day 2 SAAF Squadron received a new commanding officer, Maj Andrew Bosman, late of 4 SAAF Squadron. Exulted the record book: “….he is acknowledged not only by us, but by the RAF, as not only one of the best, but the best fighter pilot in the Western Desert!” He arrived just in time to lead the unit in the heaviest fighting of the month next day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Five Cant.Z.1007bis of 190"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia took off at 1920 to bomb Tobruk again.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_95.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 25 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At dawn Flt Lt Scade and Flg Off Chatfield of 73 Squadron each claimed to have damaged a Ju 88 over Tobruk. Early in the morning 12 Ju 87s of I./StG 3 took off to attack shipping in Tobruk harbour, escorted by eight Bf 109s of 6./JG 3 as close cover, 14 of I./JG 27 as top cover, 17 of II./JG 27 as indirect cover, 13 of III.Gruppe and 13 Italian fighters of 6° Gruppo in a waiting position to provide additional cover during the return flight.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Against this force, eight Kittyhawks of 260 Squadron, 12 Tomahawks of 4 SAAF Squadron, and several Tomahawks with two Kittyhawks (which had just been passed to 2 SAAF Squadron by 94 Squadron) were scrambled. Six of the 260 Squadron aircraft made the initial interception, catching 11 Ju 87s just as they finished bombing; Sqn Ldr Hanbury claimed one and also claimed an MC.202, but he was hit and force-landed near Gazala. No Italian claims or losses were recorded, and it remains possible therefore, that his second opponent may have been a Messerschmitt. A second Ju 87 was claimed by Plt Off Miller, but he too was shot down and another two of the unit’s aircraft were damaged. Two more Axis fighters were claimed by the unit’s pilots and two were indeed shot down in the Gazala area, both pilots surviving and returning safely later.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The South Africans had less success and suffered fairly severe casualties. Lt de Waal of 2 SAAF Squadron was shot down after repeated attacks by three Bf 109s, having himself claimed a probable and a damaged. He only just got out of his fighter before it burst into flames. One more of the unit’s aircraft was hit and was badly damaged. 4 SAAF Squadron again “just jumped in”, Maj Moodie having his controls shot away and crash-landing five miles south-east of Gazala. Lt Langaard baled out over the sea and got into his dinghy, but had suffered severe burns. He reached the coast, but was lost on 10 May when the hospital ship "), _c('i', [_vm._v("Ramb IV")]), _vm._v(", on which he was a patient, was sunk by enemy action. Meanwhile, the squadron’s haul was limited, amounting to one probable and three aircraft damaged, to which the wing leader, Wg Cdr Beresford, added two more.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("The Luftwaffe claims were once again very accurate considering the involved nature of the fight, ten fighters being claimed for an actual WDAF loss of seven destroyed or crash-landed, and four damaged, two of them badly. Apart from the two JG 27 Bf 109s that had been shot down, six Stukas had been hit by fighters or AA, one of these being shot down by the former. One of the JG 3 Messerschmitts had also been hit by AA and crash-landed at Martuba on return, although suffering only 10% damage, while a ")]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("III./JG 27 aircraft crash-landed here, 25% damaged.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Charles Laubscher had a somewhat different recollection of this particular mission:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“As 2 Squadron was only on standby I borrowed a Kittyhawk for a brief test flight [Laubscher gives the impression that he has borrowed this from 4 SAAF Squadron but at that time the only unit in 233 Wing with Kittyhawks was 260 Squadron – Author]. I tried out the guns (6 x .5”) and was impressed by their fire power and the tracer which were clearly visible – also by the machine’s power and manoeuvrability, the excellent field of vision from the cockpit and, inter alia, the pilot’s relief tube! Landed after 20 minutes and, as I was taxying in, all squadrons in the wing were scrambled. Took off without changing aircraft, with 11 Tomahawks from 2 Squadron, 12 Kittyhawks from 4 Squadron [No – Tomahawks at this time – Author] and 12 Kittyhawks from a RAF squadron in the wing [Yes – 260 Squadron – Author]. Climbed at full bore as Control’s orders had been ‘Buster’, all aircraft virtually in a straight line hoping to catch a Stuka squadron which had bombed the troops etc at Tobruk. The squadron at the north end of the line [? No 4] tallyhoed as they saw the Stukas flying low over the Gulf of Gazala, and the other two squadrons swung north-west towards them in time to be met by a mixed gaggle of 109Fs and Macchi 202s, numbering about 35 to 40 aircraft. What I believed to be the biggest dogfight of the desert war developed. One moment two or three of us would be firing at a single enemy aircraft, the next you were dodging an attack from two or three 109s or Macchis. Classic remark over the R/T from Lt Syd Cohen of 4 Squadron who was being given a particularly torrid time by four 109Fs: ‘Christ, do these bloody Germans think I’m the only Jew in the South African Air Force!’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Whilst weaving around I saw a 109F creeping up the tail of a Kittyhawk about 300 feet below and the same distance ahead of me. I yelled out over the R/T: ‘Kittyhawk below me – turn, for Christ’s sake turn!!’ He must have heard me loud and clear for he went into a steep turn to starboard immediately, followed by the 109F which could not lay off a deflection. I cut the corner diving towards them, allowed as much deflection as I dared (my reflector sight dot was on the Kittyhawk’s fuselage) and fired a long burst. Saw good strikes on the 109F’s wings and fuselage and he slid slowly downwards into a steep dive. Couldn’t follow him as I had to dodge an aircraft attacking me from my port stern quarter. Attacked another 109F head on and saw a streak of fire along his cowling as I passed over him. Chased another 109F to Tmimi, firing at long range. Tracers appeared to strike him, but tracers can be deceptive and he did not go down. Nearly jumped twice by 109Fs but outmanoeuvred these aircraft. Chased another 109F out to sea but could not catch him so I returned to the combat area. Sky was now clear of aircraft so I headed back to base, guns almost limp from all their efforts. Armourers advised that I had fired 1,100 rounds (including the short test burst naturally). The wing lost six aircraft in the engagement and we heard later that enemy losses were similar.” [Such was the power of wartime propaganda and wishful thinking! – Author]")])])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_96.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_97.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 26 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During an early Freie Jagd, Hptm Maack of I./JG 27 shot-up and claimed to have set alight two armoured cars. An hour later at 1015, four III.Gruppe aircraft undertook a similar mission; over Tengender when flying at low level, they intercepted two aircraft which were identified as both being Curtiss fighters. In fact these were a Tomahawk, flown by Lt Booth, and a Hurricane, flown by Capt Nel, both of 40 SAAF Squadron on a TacR sortie. Lt Gruber shot down Booth’s aircraft, the pilot crash-landing and the aircraft nosing over, but Nel made good his escape and returned to base.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the day 3 RAAF Squadron moved to Gambut to join 112, 250 and 450 Squadrons, 239 Wing now being established here under the leadership of Wg Cdr H.C.Mayers. From Martuba, 6./JG 3 now returned to Sicily, having gained no victories during its short stay in North Africa.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_98.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 27 April 1942")])]), _vm._v(" "), _c('table', {
    staticClass: "td2",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Wüstennotstaffel")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Fi 156C-1 WNr 0701 damaged beyond repair on the ground at Martuba by raid")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 28 April 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("In the afternoon six III./JG 27 Bf 109s again flew a Freie Jagd over Gazala, reporting an engagement ")]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("with 18 Curtiss fighters, one of which was claimed to have been shot down in flames by Oblt Heinecke. The WDAF unit involved has not been discovered.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Four 190"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia’s Cant.Z.1007bis bombers took off at 1935 to bomb Tobruk. Over the target the fourth to arrive was hit by heavy AA, the pilot being wounded in one arm; the copilot and one gunner were also wounded by splinters. Despite his serious injury, the pilot, Ten Umberto Lorenzi, managed to reach Derna where he force-landed at 2215. All those with wounds were taken to Derna hospital, but Lorenzi died there next day. He was awarded a Medaglia d’Argento al valor militare ‘in memoriam’.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_99.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 29 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Two Bf 109Fs of II./JG 27 escorted two Bf 109Es on a reconnaissance mission during which the pilots reported being attacked by four fighters near El Adem. Obfw Krenz’s Bf 109F was badly damaged, but he returned to base. Again, the identity of the WDAF unit involved has not been identified. 450 Squadron now left 239 Wing for the moment, being withdrawn for a short rest at this point.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("6./JG 27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Bf 109F-4 trop 20% damaged by P-40 SW El Adem, landed safely at base; Obfw Herbert Krenz safe")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 30 April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On this date a most memorable event occurred when 145 Squadron, which had just arrived at Helwan, unloaded its Spitfire Vbs, the first to reach North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "h1a"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDLE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAINING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUADRONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At this stage five Middle East training squadrons were set up, initially within AHQ, Egypt, to provide a variety of advanced training. The first of these actually to come into being on 23 March 1942 was 3 METS at Amman which took over the Ground Gunner School at Helwan, training personnel in administration, gunnery, fire fighting and aircraft recognition. It was followed on 5 April by 1 METS at El Ballah. This unit was formed from within 233 (Fighter) Wing, which had set up a Conversion and Refresher School in late February. It now comprised an air fighting squadron with ten Hurricane Is, four Mark IIs and eight Kittyhawks, a conversion and refresher squadron with ten Kittyhawks, six Tomahawks, four Harvards, two Blenheims and two Baltimores to provide appropriate courses for all OTU fighter pilots out from the UK, and air fighting and firing courses for fighter pilots generally. It was intended that an instructor’s training school would subsequently be added.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The third unit, 2 METS, was formed within 235 Wing of 205 Group at Shallufa to provide refresher and conversion courses for medium and heavy bomber crews. It moved to 238 Wing at Kabrit on 27 May. Also formed within 205 Group was 4 METS, mainly to train general reconnaissance and transport crews, for which it was equipped with four Wellingtons. This unit was formed on 1 May and was also based at Kabrit. Finally came 5 METS, also within 238 Wing at Kabrit, and formed on 16 May. This was actually the ex-Torpedo Bombing School, which provided a six weeks course on torpedo bombing, employing a variety of aircraft, notably Beauforts, Wellington VIIIs, and ultimately Marauders, Beaufighters and Baltimores.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 1 May 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("At 0040 Sqn Ldr Ward and two other pilots of 73 Squadron took off to carry out a night strafe of Barce. Arriving there at 0130, Ward spotted what he took to be a four-engined transport aircraft over the airfield and shot this down in flames. A Cant.Z.1007bis of 191"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia had set off at 2100 to bomb Gambut and Menastir airfields, but on return from the sortie to Barce, the aircraft was attacked just before landing ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("by a night fighter which was believed to be a Beaufighter, and the bomber was shot down at 0025 the next day. In practice this all seems to be the same combat, despite the very faulty aircraft recognition. During this attack, Flg Off Badger’s Hurricane was hit in the wing by Flak and caught fire, but after ten minutes the flames subsided and he got back safely.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Soon after dawn 2 SAAF Squadron on a wing sweep near Bir Hacheim, fought briefly with three Bf 109s of I./JG 27, but neither unit suffered any loss. 208 Squadron, which had been off operations during April, returned to the front area, re-organised on a three-flight basis, one with eight Tomahawks, the other two with 12 Hurricane Is, three of which were unarmed photo-reconnaissance machines. The unit’s duties were now specified as being tactical reconnaissance rather than army co-operation. Training continued and the unit was promised re-equipment with Kittyhawks, but in the event this never happened.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_100.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 2 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Three Bf 109s escorted nine Bf 110s to strafe east of Segnali South. One Bf 110, apparently struck by ground fire, hit the ground and crashed, another at once landed alongside to pick up the crew.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eleven MC.202s of 17° Gruppo took off at 1005 from Martuba to escort a lone Cant.Z.1007bis MM 24258 flown by Ten Enzo Antonozzi of 190"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia on a photo-reconnaissance mission over the El Mtelin area.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("112 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AK578 ‘V’ damaged in combat Cat II; Plt Off F.F.J.Edwards safe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("112 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AK957 ‘D’ damaged in combat Cat II; Plt Off F. Knoll safe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("III./ZG 26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("Bf 110E-2 WNr 3733 crashed due to ground fire; crew picked up and rescued by another aircraft of the unit")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 3 May 1942")])]), _vm._v(" "), _c('table', {
    staticClass: "td2",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("80 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane IIc BE360 collided with BE712 nr Gazala; Sgt R.H.Thomas KiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("80 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane IIc BE712 collided with BE360; Plt Off C.N.Maynard injured, then died or killed on a hospital ship 10 May 1942, DoI")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday-Wednesday, 3-6 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The weather was very bad, operations being severely curtailed.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 6 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("238 and 274 Squadrons moved to Gambut, the former unit at last receiving Hurricane IIs. The British and Commonwealth forces were now building up ready for a new offensive which it was intended should be launched from the Gazala line during June. WDAF fighter strength particularly, was being augmented. On patrol during the afternoon, Capt Duncan of 5 SAAF Squadron intercepted and claimed to have probably destroyed a Ju 88 over a convoy north of Sidi Barrani. This may have been an aircraft of 1.(F)/122 which crash-landed at Trapani, Sicily.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_101.jpg"
    }
  })])])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('b', [_vm._v("Thursday, 7 May 1942")])])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Two Tomahawks of 40 SAAF Squadron set off on a TacR sortie. Two MC.200s of 82"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia, 13° Gruppo, also took off on an early morning reconnaissance of the Tengender-Segnali South area. While so involved, they were engaged by the two South African pilots and were both shot down, one pilot being killed and the other returning on foot.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_102.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Bf 109F WNr 8480 crash-landed near Tmimi by Lt Hans-Arnold ‘Fifi’ Stahlschmidt of 2./JG 27 on 7 May after being hit by ground fire.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the evening six Kittyhawks of 3 RAAF Squadron and six of 112 Squadron were scrambled over Tobruk, then sweeping over the Axis lines. On return they were attacked by two Bf 109s of I./JG 27 which had taken off to intercept. Lt Stahlschmidt had got into a good position behind one of the Kittyhawks, when one of his guns blew up, damaging his engine. He fled, crash-landing near Tmimi where his Messerschmitt was burnt out. Sqn Ldr Gibbes, the Australian unit commander, and Plt Off Edwards of 112 Squadron each claimed a Messerschmitt shot down. Bobby Gibbes: “Two 109Es tried to attack us north of Bir Hacheim. A 112 pilot got one and the other was given to me. It seems that they both went down and were confirmed by the army. I didn’t even claim it as damaged. Fired a couple of bursts at it and then forced it into a head-on. Last I saw it was going like hell in a dive towards its territory. Pilot must have died of fright!”")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_103.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_104.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 8 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Two I./JG 27 Bf 109s flew a Freie Jagd in the Sidi Barrani area, meeting what they took to be a Beaufighter, and this was shot down by Lt von Lieres; this appears actually to have been a Maryland of 60 SAAF Squadron on a mapping sortie which was shot down by a Bf 109 soon after taking off. Two Tomahawk pilots of 5 SAAF Squadron were practising formation flying and shadow firing when they spotted a vertical column of smoke, obviously from the crashed Maryland, and were about to investigate when they were jumped by the two Messerschmitts, von Lieres shooting down one, which crash-landed; the second was also hit by cannon shells and the pilot was slightly wounded.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_105.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 9 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Between 0255-0530 three Cant.Z. 1007bis of 86° Gruppo bombed the water reservoir and aqueduct southwest of Tobruk, claiming that the targets were hit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In covering the withdrawal of Bostons which had been attacking shipping in Benghazi harbour, pilots of 12 Kittyhawks of 3 RAAF Squadron spotted a Bf 110 with a top cover of Bf 109Es almost certainly aircraft of 4.(H)/12. Sqn Ldr Gibbes attacked the Bf 110, claiming to have inflicted some damage before returning to base. Lt Jack Webb of 40 SAAF Squadron on a TacR had to crash-land in Axis-held territory")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_106.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 10 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("40 SAAF Squadron was involved in action again when two of the unit’s Hurricanes were intercepted near Martuba by a pair of I./JG 27 Bf 109s on a Freie Jagd. Oblt Marseille, newly-promoted, shot down both, one crashing and the other belly-landing; he then landed at his own base at 0930. This engagement was the first in North Africa for the Luftwaffe to be directed from a ‘Freya’ radar set. In the afternoon 250 Squadron suffered the first loss of one of its Kittyhawks when Sgt Tweedie, one of six pilots on a strafing mission, was shot down by Flak and killed.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("During the day 94 Squadron received a great shock when ordered to pass all Kittyhawks to 2 SAAF Squadron and withdraw to the Delta area. Flt Lt J.E.A.Williams, Flt Sgt J.F.Edwards and five of the other more experienced pilots were posted to 260 Squadron. Having taken such a beating on both Hurricanes and Kittyhawks, 94 had, despite intensive retraining, still suffered losses which far outstripped claims. The unit was re-equipped with Hurricanes for patrol duties in the Eastern Mediterranean and later, over the Greek Aegean islands. However, it would be many months before it would return to frontline duties. In taking over this new equipment, 2 SAAF Squadron, which had carried the code letters TA on its Tomahawks, was now allocated DB. Similarly, when moving from Tomahawks to Kittyhawks in July, the 4 SAAF Squadron code would change from DX to KJ. On reverting to Hurricanes after passing ")]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("its Kittykawks to the South African unit meanwhile, 94 was changed from FZ to GO, and indeed at much the same time 260 Squadron changed from MF to HS.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_107.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Martin Baltimore IIs of 55 Squadron; the aircraft in the foreground is AG781 ‘B’.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eighth Army and WDAF were now preparing for further intensive action, but so too were the Luftwaffe and the Regia Aeronautica. At this stage an additional 40 Ju 87s, 30 Bf 109s and 15 Bf 110s were despatched from Sicily to Africa, bringing Luftwaffe strength to some 260 aircraft. New Allied squadrons had also arrived, but these were mainly allocated to relieve more experienced units in the rear areas, freeing the latter for the front. 7 SAAF Squadron arrived from South Africa, being equipped with Hurricanes as the fifth pure fighter unit from the Union. The squadron was initially sent to Palestine where it was joined by 134 and 417 Squadrons from England – the latter the first unit of the Royal Canadian Air Force to reach the Middle East – but both squadrons at this stage were without aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As already described, 92 and 145 Squadrons had also been posted to North Africa, the latter with their Spitfires. 46 Squadron had been in the area for some months awaiting aircraft, its own Hurricanes having been delivered direct to Malta where they had remained and been renumbered as 126 Squadron (see "), _c('i', [_vm._v("Malta: The Hurricane Years, 1940-41")]), _vm._v("). The ground party thus now formed the basis for the second Beaufighter night fighter squadron, moving to Edcu during May to begin operations.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("6 Squadron, after months of relative inactivity, moved to Shandur to convert to Hurricane IId antitank aircraft which carried a 40mm gun firing armour-piercing ammunition, beneath each wing. The unit received a high-level visit at this time to advise the commanding officer that at least one flight was required to be fully trained and ready to move up to the front by the end of the month.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Two of the bomber units, 55 and 223 Squadrons, received new equipment in the form of the Martin Baltimore, a development of the already familiar Maryland. These aircraft, however, would be delayed in entering action fully due to considerable and on-going problems with their defensive armament. More details of these various units during the period when they were serving in the rear areas will be found in ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(" until such time as they moved forward into the battle area.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_108.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('b', [_vm._v("Monday, 11 May 1942")])])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A lone Cant.Z.1007bis of 191"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia flown by Ten Aldo Ulmi, set off from Derna at 1410 on a photo-reconnaissance sortie over the Giarabub-Siwa area. Analysis of the photos taken showed a number of tents and about 80 vehicles around Giarabub which were interpreted as being units of the LRDG.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 12 May 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("The day was marked by a WDAF offensive to intercept formations of Ju 52/3m transport aircraft carrying supplies and reinforcements from Crete to North Africa. Full details of this day’s activities will be found in ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(", as it involved operations considerably different to those being undertaken over the front, even though including certain of the same units. For that reason the claims and losses related to the units taking part are repeated here as well.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_109.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 13 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Twelve Kittyhawks of 3 RAAF Squadron were scrambled on an interception patrol over El Adem, but were then ordered to Bir Hacheim. A further vector to Gazala followed, where they were bounced by two Bf 109s of I./JG 27, Oblt Marseille shooting down two of them in flames, one pilot being killed and the other baling out, slightly wounded. The dead pilot, Flg Off Pace, was found to have been killed by a single bullet that had passed vertically through the top of his cockpit canopy. Marseille’s own aircraft was hit in the oil tank and propeller by fire from Chinchen’s Kittyhawk.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_110.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('b', [_vm._v("Thursday, 14 May 1942")])])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("238 Squadron, re-equipped with Hurricane IIbs, moved to LG.121 at Sidi Barrani as part of 234 Wing. A Cant.Z.1007bis of 191"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia flown by Ten Generali, took off from Gialo where it had landed on the previous day. As Generali headed back for Derna, he ran out of fuel and had to force-land 40km east of Marada. The aircraft would be recovered two days later when Cap Vecellio-Reane sighted the lost aircraft and landed alongside, slightly damaging his own aircraft in doing so. He therefore refuelled Generali’s aircraft from his own and flew it back to Barce.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("40 SAAF Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane 2627, unspecified enemy action, force-landed out of fuel; Lt D.F.Acutt")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 15 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("274 Squadron despatched eight Hurricanes to escort two TacR aircraft over the front. Due to the recent heavy losses suffered by the TacR units, it had been decided that in future these aircraft should receive a fighter escort again whenever possible. This was the first such occasion for the new policy, but in this case it was intense Flak which was encountered near Bir Hacheim, damage causing Sgt Dodds to force-land and inflicting damage on a second Hurricane. Later in the day six Kittyhawks of 250 Squadron strafed the Derna-Barce road, but during this sortie Plt Off Copeland also force-landed due to Flak damage, returning on 17 May.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Regia Aeronautica units were on the move, 150° Gruppo withdrawing from Martuba to Benghazi K3, committed mainly to harbour defence. The unit’s place nearer the front would be taken by 8° Gruppo, also equipped with MC.200s. At the same time 158° Gruppo Assalto, led by Cap Alessandro Cerutti (236"), _c('sup', [_vm._v("a")]), _vm._v(", 387"), _c('sup', [_vm._v("a")]), _vm._v(" and 388"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglie), equipped with CR.42s, moved from Sorman to K3. Ghiblis of 12"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia APC were active searching for the force-landed 191"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia Cant.Z. 1007bis in the desert. Next day this unit would move to Agedabia.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("250 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AL104 left 1520, shot down by Flak, Derna-Barce flew back two days later; Plt Off P Copeland safe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("274 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane II force-landed, Flak; Sgt J.Dodds")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("274 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane II damaged by fighter; Sgt TB.Hamilton")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 16 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("40 SAAF Squadron experienced its first full escort when six Tomahawks of 4 SAAF Squadron accompanied one of its own aircraft over the front. On this date 112 Squadron became the first Kittybomber unit when Flt Lt Bartle led six bomb-carrying aircraft to attack Tmimi. During the day also 5 SAAF Squadron arrived at LG.115, Gasr el Arid, to join 233 Wing, moving into 94 Squadron’s old dispersal area. The other members of the wing were now 260 and 2 SAAF Squadrons with Kittyhawks, and 4 SAAF Squadron, which like 5 SAAF, still flew Tomahawks.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At 1810 12 Kittyhawks of 3 RAAF Squadron and nine of 450 Squadron were scrambled to patrol over the Gazala area where they were attacked by three Bf 109s. These aircraft were from I./JG 27 and had taken off a little earlier for a Freie Jagd four-strong; one had returned early. Seeing the 3 RAAF aircraft at 1905, flying at 16,000 feet, Oblt Marseille dived on them, but was attacked by six. He broke away and climbed up behind the other six, shooting down Sgt Teede in a sharp turn to port; Teede crash-landed on fire west of El Adem.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Marseille pulled up again as he was once more attacked by six Kittyhawks, circling this formation and making a series of short diving attacks without result. By this time the Kittyhawks were down to about 1,900 feet, and he then shot down the leading aircraft of a flight of four from 450 Squadron at 1915 while in a wide turn to port. The pilot baled out, his falling aircraft striking another which crashed. Marseille was already on his way back to base and failed to see this, claiming only two victories.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_111.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_112.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sunday, 17 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("250 Squadron welcomed back one of its pilots, Sgt Baron, who had been shot down four and a half months previously. 208 Squadron moved from Ismailia to Sidi Aziez to resume operations with one flight of Tomahawks and two of Hurricanes.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 18 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Early in the day six Kittybombers of 112 Squadron, covered by four more in fighter mode, undertook a bombing and strafing attack during which Plt Off Fisher was shot down in flames by Flak, while Sgt Davey crashed near Bir Temrad. Sgt Drew hit the ground with his propeller and force-landed 12 miles south of Gambut; Flak crews claimed two P-40s shot down. Two hours later six Bf 109s of newly-formed 10. (Jabo)/JG 27 attacked a tented camp east of the El Adem-Tobruk road. Lt Weinfurtner failed to return, ditching in the sea and drowning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Two RAF squadrons received new commanders during the day. Sqn Ldr G.V.W.Kettlewell, a Greek campaign veteran, was now replaced as leader of 213 Squadron by Sqn Ldr M.H.Young, DFC, recently a flight commander in 73 Squadron and in 1940 a Defiant pilot in the Battle of Britain. 33 Squadron was taken over by Sqn Ldr J.E.Proctor, DFC, another Battle of Britain pilot who already had some 12 victories to his credit.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("112 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AK763 shot down by Flak during ground attack; Plt Off J.R.Fisher KiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("112 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AK766 damaged by Flak during ground attack; Plt Off W.A.J. Johnston safe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("112 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AK994 shot down over Temrad during ground attack; Sgt J.VDavey MiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("112 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Kittyhawk I AK906 force-landed near Gambut; Sgt R.A.Drew safe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("80 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane II BE973, crashed on take-off; Sgt G.D.Nicholls KiFA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Claims")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("Flak")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2a"
  }, [_vm._v("2 P-40s")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Tuesday, 19 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At 0715 nine Kittyhawks of 450 Squadron carried out a patrol near Gazala. Two aircraft returned early, the others splitting up into two sections of three and four respectively. At 0820 Oblt Marseille and his wingman on a Freie Jagd, dived on the smaller section, hitting one Kittyhawk which fell out of the formation, damaged in wing and rudder, and force-landed at Gambut Main. The second aircraft in the formation tried to engage, but fell into a spin, recovered in cloud, but thereby left Sgt Young alone. The intrepid Young climbed after the attackers to 20,000 feet where both Messerschmitts turned on him, so he dived for the clouds. However, Marseille put a burst into his engine, which stopped. Young weaved and crash-landed, his aircraft being shot-up on the ground by the German pilots and burnt out. Young evacuated the aircraft safely and was picked up by the army, returning safely to Gambut.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_113.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wednesday, 20 May 1942")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("This day saw the return of III./JG 53 to Martuba from Sicily and Crete, and Maj Gerlitz was posted ")]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("from JG 27 to command this unit. With his departure, Hptm Rödel took over command of II./JG 27, Oblt Düllberg becoming the Geschwader Adjutant. At this stage the Staffelkapitäne of III./JG 53 were Oblt Franz Götz (33 victories) 9.Staffel, Hptm Helmut Belser (32 victories) 8.Staffel, and Oblt Wilfried Pufahl (ten victories) 7.Staffel.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Thursday, 21 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Nine Kittyhawks of 260 Squadron carried out a sweep from 0735 to cover returning SAAF bombers in the Tmimi-Gazala area. Here the unit attacked two Bf 109s of JG 27’s Geschwaderstab to the east of Tmimi, Fw Gromotka crash-landing. 33 Squadron flew an escort to a pair of TacR aircraft, but over Bir Hacheim the unit’s new commanding officer, Sqn Ldr Proctor, was hit by Flak and force-landed.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_114.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Friday, 22 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Luftwaffe’s fighters now began operating from Tmimi as well as Martuba, and activity on both sides increased as each opponent strove to be ready, each being well aware that the other was fast approaching readiness to launch a new offensive.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At 0730 on this date 12 Kittyhawks from 250 Squadron with others of 112 Squadron, escorted nine Bostons of 24 SAAF Squadron, now back on operations, to bomb the familiar targets at Martuba. At the same time 12 3 RAAF Squadron fighters with 260 Squadron as close cover and 450 Squadron higher up, carried out a freelance bomber escort as a diversion to the main thrust. Around much the same time four Bf 109s of II./JG 27 had commenced a Freie Jagd, and these encountered the diversionary formation, diving on the top cover and shooting down two Australian Kittyhawks 30 miles east of Tmimi, also damaging two more; three claims were made by the Germans, all for aircraft reported to have crashed into the sea. Two Bf 109s were claimed in return by pilots of 3 RAAF and one probable by 450 Squadron; no losses were recorded by the Luftwaffe on this occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Sqn Ldr Gibbes:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Were attacked by four 109s over Gulf of Bomba. Got split up and didn’t carry out original job. Two 109s attacked top cover and two attacked by section. Attacks nicely executed. Subsequently, attacks rather weak and showed pilots of 109s to be very inexperienced. Got shot at one 109 which attacked ‘Yellow 2’ (Sgt Thomas). Pulled round and got a good burst into it. Later Sgt Kildey confirmed it for me. I didn’t even claim it as damaged as I did not know if I hit it. Out-dived two 109s and got a burst into each. Didn’t observe results as was busy clearing own tail. Formation by this time split up, so climbed to 15,000 feet over Gazala and joined bombers on their way home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Meanwhile from Martuba eight Messerschmitts of I.Gruppe and three of III.Gruppe plus six MC.202s of 17° Gruppo scrambled, attacking 112 and 250 Squadrons, the German pilots claiming six Curtiss fighters plus one unconfirmed; two were actually lost by 112 Squadron and one from 250 Squadron was damaged, crash-landing on return. During the return flight Flg Off Waddy claimed one Messerschmitt shot down. The Italian pilots were able only to claim damage to one of the Bostons on this occasion. One III.Gruppe Bf 109 was lost during the day, the pilot baling out south of Martuba following engine failure, while a Bf 110 of 4.(H)/12 crash-landed at Martuba, suffering 40% damage. A Ju 88 of 5./LG 1 was shot down by AA over the Mersa Matruh area.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("Somewhat later in the morning a lone MC.202 of 79"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia flown by Serg Magg Amedeo Benati scrambled at 1005 to intercept a reconnaissance aircraft sighted over Benghazi. Catching this, he identified it as a Blenheim which he claimed to have shot down 30km off the coast (see also ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_115.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Bf 109F ‘White 11’ of 4./JG 27 with the Staffel emblem beneath the cockpit and that of II Gruppe on the nose.")])])])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Barce received reinforcements for its resident Cant.Z.1007bis when 15 more of these aircraft arrived, led by the 35° Stormo BT commander, Col Bruno Borghetti. These were aircraft of 95° Gruppo (Magg Pietro Zigiotti) comprising 230"), _c('sup', [_vm._v("a")]), _vm._v(" and 231"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglie led by Cap Augusto Fusco and Cap Francesco Casadio respectively.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_116.jpg"
    }
  })])]), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_117.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Saturday, 23 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During a busy day six separate engagements took place, these involving in the main the Bf 109s of II./JG 27. This unit submitted a considerable number of claims, some of which have defied attempts to verify.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At 0815 80 Squadron’s Hurricanes took off to patrol over El Adem, as a number of Kittyhawks were refuelling there. They were jumped by four Bf 109s of II.Gruppe on a Freie Jagd, two of them being shot down in flames, both crashing near Tobruk with one more crash-landing. About an hour later four more of this Gruppe’s Messerschmitts attacked Hurricanes of 33 Squadron as these were patrolling over a convoy, claiming three which were confirmed plus one probable. However, the latter was credited to the pilot of a 6° Gruppo MC.202, four of this unit’s aircraft having scrambled from Martuba and become engaged in this combat. Oblt Rödel, who made two of the claims, reported that he had shot down the leader of the British formation which went into the sea, seeing the pilot swimming away. This would appear to have been Flt Lt Wade who had been leading the 33 Squadron patrol; his was one of two of this unit’s Hurricanes which failed to return. This was D.P.Wade not to be confused with Lance Wade who also served with this unit. Six more Bf 109s had followed Rödel’s Schwarme a few minutes later, and one of the pilots of these, Obfw Bendert, claimed a fighter in flames ten miles south of Gazala, reporting that another disappeared into cloud trailing black smoke. Almost needless to say, in every case II.Gruppe identified its opponents as P-40s. Only the Italian pilot correctly claimed his victim as a Hurricane.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An hour later eight Bf 109s of I.Gruppe were scrambled, intercepting the Baltimore bombers of 223 Squadron on their first operational flight. These were incorrectly identified as Douglas DB-7s (i.e. Bostons). As with every new light or medium bomber to arrive in the Middle East, the Baltimores were sent out initially without fighter escort – the authorities had apparently still not accepted the lesson that in daylight and where fighter opposition could be expected, bombers must be escorted. On this occasion four Baltimores had been despatched to bomb Baheira satellite airfield, and one of them had lagged behind. This was caught north of Acroma by Hptm Homuth and was badly shot-up. The pilot turned back and just managed to crash-land it at base where the crew reported that the .30in rear machine guns had failed to operate. The Messerschmitts had immediately attacked the other three bombers, the rear guns of which all failed at the crucial moment, allowing the fighters to press home their attacks from 50-75 yards. Oblt Marseille shot down two in three minutes, and two minutes later the survivor was shot down by Obfw Mentnich. Two of the Baltimores fell in flames, the third crash-landing at Bir el Gobi. The surviving crew members claimed that one Bf 109 had been shot down by ‘scare’ guns fixed in the rear of the engine nacelles, although in the circumstances this was rather unlikely. Following this disastrous mission, Baltimores, like Bostons, were always escorted on day raids and the American .30in Browning machine guns in the dorsal and ventral gunners’ positions were replaced with British .303in weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the meantime a further four II.Gruppe Bf 109 s had taken off, Uffz Gierster claiming a fighter shot down, and Fw Reuter on his second sortie of the morning, claiming two, all three being claimed to have fallen into the sea near Tobruk. Eleven Kittyhawks of 2 SAAF Squadron escorted Bostons to attack airfields at Derna, but were attacked by a number of Bf 109s during the return journey. Lt Bryant lost formation and was attacked and his aircraft badly damaged by four Messerschmitts. He thought he had shaken them off when he spotted a truckload of soldiers waving frantically; looking round, he found a 109 on his tail. He turned sharply, flew through the fire of some British AA guns, and reached his airfield safely. The time of this engagement indicates that he was probably attacked by the II./JG 27 quartette mentioned.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("During the day 80 Squadron, joined by two Hurricanes of 274 Squadron, provided escort to two 40 SAAF Squadron TacR aircraft over the front. Here Sgt Cormack’s aircraft was damaged by an enemy fighter and he crash-landed at El Adem. However, Col Biden, flying one of the reconnaissance aircraft, claimed to have probably shot down an MC.202. He was probably engaged with aircraft from 6° Gruppo, eight of which had scrambled at 1040, led by Cap Giuliano Giacomelli, one pilot claiming damage to a fighter – identified as a P-40, of course!")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("During the afternoon four more II.Gruppe Messerschmitts were scrambled, attacking seven Kittyhawks of 450 Squadron which were escorting two more TacR Hurricanes over II.Gruppe’s own airfield at Tmimi. At first there was no result arising from the general dogfight which ensued until Uffz Gierster, on his second sortie, claimed one victory south-east of Gadd el Ahmar, before being shot down himself and baling out, pilots of 450 Squadron claiming two Bf 109s destroyed. The Australians suffered no losses during this engagement.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("WDAF bombing raids had achieved some success during this rather costly day, a Ju 88 of IV./LG 1 being destroyed at Berka airfield with a 1./StG 3 Ju 87 suffering a similar fate at Derna.")]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_118.jpg"
    }
  })])])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('b', [_vm._v("Sunday, 24 May 1942")])])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It was obvious that the Axis forces were going to beat 8th Army ‘to the punch’, and attack somewhere along the line. At this critical moment 145 Squadron was ordered to move its Spitfires forward to Gambut. Axis reinforcement was proceeding apace, for on the evening of this day the 54 MC.202s of 4° Stormo CT, which had been operating over Malta, arrived at Martuba, led by T Col Armando François. They joined 1° Stormo, forming a force of more than 100 MC.202s, the largest concentration of these fighters ever to be achieved in Libya. Meanwhile 50° Stormo Assalto moved to Derna’s El Fteiah airfield, ready for operations. This latter Stormo was newly-established under T Col Ferruccio Vosilla with the arrival of 159° Gruppo (389"), _c('sup', [_vm._v("a")]), _vm._v(", 390"), _c('sup', [_vm._v("a")]), _vm._v(" and 391"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglie) to join 158° Gruppo, both units equipped with CR.42s fitted as fighter-bombers. Vosilla had previously commanded 18° Gruppo CT which had taken part in the Italian expeditionary force in Belgium during autumn 1940 for operations over England.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_119.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("A patrol of MC.202s of 96"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia, 9° Gruppo, 4° Stormo CT in flight. In the foreground is ‘96-8’ MM 7927.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Next day a Comando Caccia (Fighter Command) would be established at Martuba under the 1° Stormo commander, Col Alfredo Reglieri, to co-ordinate the activities of the four MC.202-equipped units:")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("6° Gruppo (1° Stormo)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Magg Mario Larcher")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("17° Gruppo (1° Stormo)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Magg Domenico Sciaudone")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("9° Gruppo (4° Stormo)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Magg Antonio Larsimont-Pergameni")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para"
  }, [_vm._v("10° Gruppo (4° Stormo)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab-para1"
  }, [_vm._v("Magg Paolo Maddalena")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The three squadriglie of newly arrived 9° Gruppo were led by S.Ten Alvaro Querci (73"), _c('sup', [_vm._v("a")]), _vm._v("), Cap Ezio Viglione-Borghese (96"), _c('sup', [_vm._v("a")]), _vm._v(") and S.Ten Jacopo Frigerio (97"), _c('sup', [_vm._v("a")]), _vm._v("), who would be replaced by Ten Fernando Malvezzi on 1 June. The commanders of the three squadriglie of 10° Gruppo were Cap Franco Lucchini (84"), _c('sup', [_vm._v("a")]), _vm._v("), Cap Ranieri Piccolomini (90"), _c('sup', [_vm._v("a")]), _vm._v(") and Ten Orlando Mandolini (91"), _c('sup', [_vm._v("a")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the Luftwaffe, the whole of III./ZG 26 had now gathered in Libya where the unit would remain until 4 August. With StG 3 and 12./LG 1, the three units now formed a special task force known as Gefechtsverband Sigel.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("British Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("73 Sqn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Hurricane IIc BD774 shot down by Flak at night in Tmimi area; Plt Off J.Beaumont MiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("German Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("1./LG 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("Ju 88A-4 WNr 5553 L1+GH shot down by fighters, crashed nr Bir el Abd; Lt Hetterich and 3 MiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("III./ZG 26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("Bf 110F-2 WNr 4543 3U+BD crashed W Benghazi during recce off Great Sirte; Lt Helmut Scheid and 2 MiA")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('b', [_vm._v("German Casualties")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("KGrzbV 102")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("Ju 52/3m WNr 6809, destroyed by own forces in the desert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Italian Casualties")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("82"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 13°Gr, 2°St CT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("MC.200 MM 5911 damaged by bombs at Martuba")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("78"), _c('sup', [_vm._v("a")]), _vm._v(" Sq, 13°Gr, 2°St CT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para2"
  }, [_vm._v("3 MC.200s slightly damaged by bombs at Martuba")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday, 25 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Early in the morning Flt Sgt Comfort of 80 Squadron escorted Lt Nichol of 40 SAAF Squadron on a sortie over Tmimi where they were attacked by four Bf 109s of II./JG 27 and both shot down, one in flames by Lt Jenisch and one crash-landed by Fw Niederhöfer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the later afternoon 12 Hurricanes of 274 Squadron were scrambled over Tobruk and then flew to Gazala where they were engaged in a dogfight in which Flt Lt Playford was shot down, crash-landing with slight wounds. Their opponents appear to have been ten MC.202s of 6° Gruppo (four of 79"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia and six of 88"), _c('sup', [_vm._v("a")]), _vm._v(" Squadriglia) which were on a free sweep over the Ain el Gazala-Bir Hacheim area. South-east of Gazala a formation identified as 20 P-40s were seen at lower level and were bounced. The Macchi pilots reported what appeared to be a very successful attack, claiming nine of the British fighters shot down and others damaged for no loss. This does seem to have been a case of quite massive overclaiming, for the only WDAF unit which appears to have been involved was 274 Squadron and that unit suffered only the one loss. The Hurricane pilots took this attack to have been by Bf 109s, claiming one probable and two damaged in return.")]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_120.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("One of the first of the new Spitfire Vs to reach Egypt. The aircraft carries a single number at this stage, prior to receiving squadron code letters.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Allied bombing of the Axis airfields had achieved a fair amount of success during the day, two Bf 109s being damaged at Martuba, with one more destroyed at Tmimi where another also suffered damage. Three MC.202s were also destroyed at Martuba.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sqn Ldr B.Drake, DFC, arrived to take over command of 112 Squadron as Sqn Ldr C.R.Caldwell was being posted to England to convert to Spitfires before going home to Australia to lead a wing of these aircraft in the war with Japan. Awarded DFC & Bar during his tour as well as achieving very rapid promotion and gaining the nickname ‘Killer’, he had claimed 20 German and Italian aircraft shot down and one more shared – the highest total for any Allied pilot while operating over the Western Desert. His successor, Billy Drake, had flown in France with 1 Squadron and in the later stages of the Battle of Britain. He had claimed seven and two shared aircraft shot down by this time and would rapidly prove to be a worthy replacement for Caldwell, becoming one of the most successful RAF fighter pilots in the Mediterranean theatre.")])]), _c('div', {
    staticClass: "fig1"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('p', {
    staticClass: "fig-img1"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_121.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Monday-Tuesday, 25/26 May 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The night brought a heavy raid in the opposite direction as LG.143, at Gasr el Arid was bombed in an effort by the Luftwaffe and Regia Aeronautica to destroy as many WDAF fighters as possible before the new offensive began. The raiders approached before midnight on 25 May, resulting in some confusion in the records since the British claims were listed as occurring on the 25th whereas Axis losses were listed next day. The first claim was made by Flt Lt Scade of 73 Squadron at 2230, followed by a second by Flt Sgt Joyce at 2256. Their victims were both Ju 88s of LG 1. Around the same time nine CR.42s of 3° Gruppo CT made a low level attack on Gambut, releasing around 50 small bombs and strafing; one of these biplanes was shot down by Flg Off Selby. At 2345 a Ju 88C night fighter of NJG 2 was lost to AA west of Bardia; the crew were all wounded, but escaped capture and walked back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Between 0515-0730 Gambut was again attacked by 27 MC.202s of 4° Stormo, covered by 22 more MC.202s of 1° Stormo. The Italian pilots reported strafing 24 aircraft on the ground, claiming all of them destroyed or damaged.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Despite all these attacks, WDAF losses seem to have been restricted to a single Tomahawk of 4 SAAF Squadron damaged Cat II and several more such aircraft of 4 SAAF and 5 SAAF Squadrons slightly damaged by splinters. The South Africans reported that at dawn six MC.202s strafed at 0630, but inflicted no further damage, whereas 250 Squadron reported two Kittyhawks damaged. This would have been a great disappointment to the Italian command had they been aware.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("Around the same time another Ju 88, this one from 12./LG 1, was shot down by Bofors gunners and two Hurricane pilots of 33 Squadron jointly, the crew of this aircraft being captured. This aircraft may ")]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("also have been attacked and claimed damaged by 3 RAAF Squadron. At 0655, shortly after the attack on Gambut by the Italian fighters, 12 Kittyhawks of 3 RAAF Squadron were scrambled over El Adem to intercept four Ju 88s and six Bf 109s at 11,000 feet. Sqn Ldr Gibbes claimed a probable Messerschmitt before attacking a Ju 88 – probably the one then shot down by 33 Squadron and the Bofors gunners. Return fire from the rear gunner set Gibbes’ engine alight, causing him to bale out at 4,000 feet, striking the tailplane and getting an aerial wire entangled in his parachute. He landed heavily and broke his ankle, which caused his removal to hospital.")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Claims and losses related to the Axis attacks on Allied airfields during the night of 25/26 May 1942")])]), _vm._v(" "), _c('div', {
    staticClass: "fig1"
  }, [_c('p', {
    staticClass: "fig-img1"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_122.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696db806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01a.vue
// module id = 72
// module chunks = 0